// // // import React, { useEffect, useState } from 'react';
// // // // import './menuiteams.css';
// // // import Modal from 'react-modal';
// // // import { ShoppingCart } from '@mui/icons-material';
// // // import { useNavigate } from 'react-router-dom';
// // // import axios from 'axios';

// // // Modal.setAppElement('#root');
// // // const WaitermenuIteams = ({ parentId }) => {
// // //     const [dishes, setDishes] = useState([]);
// // //     const [filteredDishes, setFilteredDishes] = useState([]);
// // //     const [quantities, setQuantities] = useState({});
// // //     const [loading, setLoading] = useState(true);
// // //     const [error, setError] = useState(null);
// // //     const [isVegSelected, setIsVegSelected] = useState(false);
// // //     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
// // //     const [isModalOpen, setIsModalOpen] = useState(false);
// // //     const [selectedDish, setSelectedDish] = useState(null);
// // //     const [cartItems, setCartItems] = useState([]);
// // //     const [isHovered, setIsHovered] = useState(false);
// // //     const navigate = useNavigate();
// // //     const [enable, setEnable] = useState([]);
// // //     const [cartData, setCartData] = useState({ cartItems: [] });
// // //     const totalPrice = cartItems.reduce((acc, item) => {
// // //         return acc + item.price * item.quantity * 0.9;
// // //     }, 0);


// // //     const [isOn, setIsOn] = useState(false);
// // //     const handleToggle = () => {
// // //         setIsOn(prev => !prev);
// // //     };



// // //     const addToCart = async (item, quantity = 1) => {
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");
// // //         const seatingId = localStorage.getItem("seatingId");
// // //         const tableCode = localStorage.getItem("tableCode");

// // //         if (!seatingId || !tableCode) {
// // //             console.error("❌ Seating ID or Table Code not found in localStorage");
// // //             return;
// // //         }

// // //         // ✅ tableCode as query param
// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;

// // //         const data = [{ dishId: item.dishId, quantity }];

// // //         try {
// // //             const response = await axios.post(apiUrl, data, {
// // //                 headers: {
// // //                     'Content-Type': 'application/json',
// // //                     'Authorization': `Bearer ${token}`,
// // //                 },
// // //             });

// // //             if (response.status === 200) {
// // //                 // ✅ Refresh cart data from API after adding
// // //                 await fetchCartData();

// // //                 // ✅ Show temporary modal
// // //                 setIsModalOpen(true);
// // //                 setTimeout(() => {
// // //                     if (!isHovered) setIsModalOpen(false);
// // //                 }, 2000);

// // //             } else {
// // //                 console.error('Failed to add item to cart:', response.data);
// // //                 alert('Failed to add item to cart');
// // //             }
// // //         } catch (error) {
// // //             console.error('Error adding item to cart:', error);
// // //             if (error.response) {
// // //                 if (error.response.status === 500) alert('Server Error. Please try again later.');
// // //                 else if (error.response.status === 404) alert('Item not found. Please try again.');
// // //                 else alert(`Error: ${error.response.data}`);
// // //             } else {
// // //                 alert('An unexpected error occurred. Please try again.');
// // //             }
// // //         }
// // //     };





// // //     useEffect(() => {
// // //         const fetchData = async () => {
// // //             const vendorId = localStorage.getItem("vendorId");
// // //             const token = localStorage.getItem("authToken");

// // //             if (!vendorId) {
// // //                 console.warn("⚠️ vendorId not found in localStorage");
// // //                 setError(new Error("vendorId missing"));
// // //                 setLoading(false);
// // //                 return;
// // //             }

// // //             if (!token) {
// // //                 console.warn("⚠️ authToken not found in localStorage");
// // //                 setError(new Error("authToken missing"));
// // //                 setLoading(false);
// // //                 return;
// // //             }

// // //             try {
// // //                 const response = await fetch(
// // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // //                     {
// // //                         headers: {
// // //                             'Authorization': `Bearer ${token}`,
// // //                             'Content-Type': 'application/json',
// // //                             'Accept': 'application/json',
// // //                         },
// // //                     }
// // //                 );

// // //                 if (!response.ok) {
// // //                     throw new Error(`HTTP error! status: ${response.status}`);
// // //                 }

// // //                 const data = await response.json();
// // //                 console.log('API Data:', data);

// // //                 const dishData = Array.isArray(data) ? data : data.data || [];
// // //                 console.log('Dish Data:', dishData);

// // //                 const validDishData = dishData.filter(item => item !== null && item !== undefined);
// // //                 console.log('Valid Dish Data:', validDishData);

// // //                 const filteredData = validDishData.filter(item => {
// // //                     const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
// // //                     const statusCheck = item.menuStatus === "Enable";
// // //                     const quantityCheck = Number(item.balanceQuantity) > 0;
// // //                     return parentCheck && statusCheck && quantityCheck;
// // //                 });

// // //                 console.log('Filtered Dishes (balanceQuantity > 0):', filteredData);
// // //                 setDishes(filteredData);
// // //                 setFilteredDishes(filteredData);
// // //             } catch (error) {
// // //                 console.error('Error fetching data:', error);
// // //                 setError(error);
// // //             } finally {
// // //                 setLoading(false);
// // //             }
// // //         };

// // //         fetchData();
// // //     }, [parentId]);

// // //     const handleFilterClick = (type) => {
// // //         if (type === 'Veg') {
// // //             setIsVegSelected(true);
// // //             setIsNonVegSelected(false);
// // //             setFilteredDishes(dishes.filter(dish => dish.tag === 'Veg'));
// // //         } else if (type === 'Non-Veg') {
// // //             setIsVegSelected(false);
// // //             setIsNonVegSelected(true);
// // //             setFilteredDishes(dishes.filter(dish => dish.tag === 'Non_Veg'));
// // //         }
// // //     };

// // //     const authToken = localStorage.getItem("authToken");
// // //     const vendorId = localStorage.getItem("vendorId");

// // //     const fetchCartData = async () => {
// // //         if (!authToken || !vendorId) return;

// // //         try {
// // //             const response = await axios.get(
// // //                 `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
// // //                 { headers: { Authorization: `Bearer ${authToken}` } }
// // //             );

// // //             setCartData(response.data);

// // //             const initialQuantities = {};
// // //             if (response.data.cartItems) {
// // //                 response.data.cartItems.forEach(item => {
// // //                     initialQuantities[item.dishId] = item.quantity;
// // //                 });
// // //             }
// // //             setQuantities(initialQuantities);

// // //         } catch (err) {
// // //             console.error("Error fetching cart:", err);
// // //         }
// // //     };



// // //     // Assume cartData is the full cart object from API
// // //     // {
// // //     //   cartId: 52,
// // //     //   cartItems: [...]
// // //     // }

// // //     const increaseQuantity = async (dishId) => {
// // //         const token = localStorage.getItem("authToken");
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         if (!token || !vendorId) return alert("Auth token or vendorId missing");

// // //         if (!cartData || !cartData.cartItems) {
// // //             alert("Cart is empty or not loaded yet.");
// // //             return;
// // //         }

// // //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// // //         if (!cartItem) {
// // //             alert("Item not found in cart. Please add it first.");
// // //             return;
// // //         }

// // //         const newQty = (quantities[dishId] || 0) + 1;

// // //         // Correct API URL with vendorId and cartId
// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// // //         console.log("API URL:", apiUrl);

// // //         try {
// // //             const response = await axios.put(apiUrl, null, {
// // //                 headers: { Authorization: `Bearer ${token}` }
// // //             });

// // //             console.log("API Response:", response.data);

// // //             // Update state
// // //             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// // //             setCartData(prev => ({
// // //                 ...prev,
// // //                 cartItems: prev.cartItems.map(item =>
// // //                     item.dishId === dishId ? { ...item, quantity: newQty } : item
// // //                 )
// // //             }));
// // //             setIsModalOpen(true);
// // //             setTimeout(() => {
// // //                 if (!isHovered) setIsModalOpen(false);
// // //             }, 2000);
// // //         } catch (err) {
// // //             console.error("API Error:", err.response ? err.response.data : err);
// // //             alert("Unable to update quantity for dishId: " + dishId);
// // //         }
// // //     };




// // //     const decreaseQuantity = async (dishId) => {
// // //         const token = localStorage.getItem("authToken");
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const currentQty = quantities[dishId] || 0;
// // //         if (currentQty === 0) return;

// // //         if (!cartData || !cartData.cartItems) {
// // //             alert("Cart is empty or not loaded yet.");
// // //             return;
// // //         }

// // //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// // //         if (!cartItem) return alert("Item not found");

// // //         const newQty = currentQty - 1;

// // //         // Correct API URL with vendorId and cartId
// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// // //         console.log("=== Decrease Quantity API Call ===");
// // //         console.log("dishId:", dishId);
// // //         console.log("newQty:", newQty);
// // //         console.log("cartId:", cartData.cartId);
// // //         console.log("API URL:", apiUrl);

// // //         try {
// // //             const response = await axios.put(apiUrl, null, {
// // //                 headers: { Authorization: `Bearer ${token}` }
// // //             });

// // //             console.log("API Response:", response.data);

// // //             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
// // //             setCartData(prev => ({
// // //                 ...prev,
// // //                 cartItems: newQty > 0
// // //                     ? prev.cartItems.map(item =>
// // //                         item.dishId === dishId ? { ...item, quantity: newQty } : item
// // //                     )
// // //                     : prev.cartItems.filter(item => item.dishId !== dishId)
// // //             }));
// // //             setIsModalOpen(true);
// // //             setTimeout(() => {
// // //                 if (!isHovered) setIsModalOpen(false);
// // //             }, 2000);
// // //         } catch (err) {
// // //             console.error("API Error:", err.response ? err.response.data : err);
// // //             alert("Unable to update quantity for dishId: " + dishId);
// // //         }
// // //     };


// // //     useEffect(() => {
// // //         fetchCartData();
// // //     }, [authToken, vendorId]);




// // //     const handleViewCartClick = () => {
// // //         navigate('/tableCart');
// // //     };

// // //     if (loading) {
// // //         return <div>Loading...</div>;
// // //     }

// // //     if (error) {
// // //         return <div>Error loading dishes: {error.message}</div>;
// // //     }

// // //     return (
// // //         <div style={{ marginTop: '100px' }} className='menuiteams-data'>
// // //             <div
// // //                 style={{
// // //                     display: "flex",
// // //                     flexWrap: "wrap",
// // //                     gap: "1rem",
// // //                     marginBottom: "1rem",
// // //                     justifyContent: "center",
// // //                 }}
// // //             >
// // //                 <style>
// // //                     {`
// // //                         @media (max-width: 768px) {
// // //                             .offers-containers {
// // //                                 grid-template-columns: repeat(2, 1fr) !important;
// // //                                 gap: 15px !important;
// // //                             }
// // //                             .offers-cards {
// // //                                 width: 100% !important;
// // //                                 max-width: 100% !important;
// // //                             }
// // //                             .responsive-button-group {
// // //                                 flex-direction: column !important;
// // //                                 align-items: center !important;
// // //                             }
// // //                             .responsive-button {
// // //                                 width: 90% !important;
// // //                                 text-align: center;
// // //                             }
// // //                             .custom-switch-wrapper {
// // //                                 margin-top: 10px;
// // //                                 width: 90% !important;
// // //                             }
// // //                         }
                        
// // //                         @media (max-width: 480px) {
// // //                             .offers-containers {
// // //                                 grid-template-columns: 1fr !important;
// // //                             }
// // //                             .offers-cards {
// // //                                 margin: 0 auto !important;
// // //                             }
// // //                             .card-body {
// // //                                 padding: 10px !important;
// // //                             }
// // //                             .card-title {
// // //                                 font-size: 18px !important;
// // //                             }
// // //                         }
                        
// // //                         @media (max-width: 320px) {
// // //                             .offers-cards {
// // //                                 width: 95% !important;
// // //                             }
// // //                             .card-body {
// // //                                 padding: 8px !important;
// // //                             }
// // //                             .card-title {
// // //                                 font-size: 16px !important;
// // //                             }
// // //                         }
                        
// // //                         .custom-switch {
// // //                             position: relative;
// // //                             display: inline-block;
// // //                             width: 100px;
// // //                             height: 35px;
// // //                         }
                        
// // //                         .custom-switch input {
// // //                             opacity: 0;
// // //                             width: 0;
// // //                             height: 0;
// // //                         }
                        
// // //                         .custom-slideryy {
// // //                             position: absolute;
// // //                             cursor: pointer;
// // //                             transition: 0.4s;
// // //                             font-weight: bold;
// // //                             font-size: 14px;
// // //                             color: #000;
// // //                             text-align: center;
// // //                             line-height: 35px;
// // //                             width: 100px;
// // //                             height: 40px;
// // //                             border-radius: 5px;
// // //                             background-color: rgb(217, 217, 217);
// // //                         }
                        
// // //                         .custom-slideryy::before {
// // //                             content: "";
// // //                             position: absolute;
// // //                             height: 16px;
// // //                             width: 16px;
// // //                             left: 3px;
// // //                             top: 10px;
// // //                             background-color: #000;
// // //                             transition: 0.4s;
// // //                             border-radius: 50%;
// // //                         }
                        
// // //                         .custom-slideryy.veg::before {
// // //                             background-color: green;
// // //                         }
                        
// // //                         .custom-slideryy.non-veg::before {
// // //                             background-color: red;
// // //                         }
                        
// // //                         .custom-switch input:checked + .custom-slideryy::before {
// // //                             transform: translateX(60px);
// // //                         }
// // //                     `}
// // //                 </style>

// // //                 <div className="responsive-button-group menu-responsive-buttons-code" style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "center", alignItems: "center" }}>


// // //                     <div className="custom-switch-wrapper" style={{ position: "relative", top: "-12px", left: "-20px" }}>
// // //                         <label className="custom-switch">
// // //                             <input
// // //                                 type="checkbox"
// // //                                 checked={isVegSelected}
// // //                                 onChange={() => handleFilterClick(isVegSelected ? "Non-Veg" : "Veg")}
// // //                             />
// // //                             <span className={`custom-slideryy ${isVegSelected ? "veg" : "non-veg"}`}>
// // //                                 {isVegSelected ? "Veg" : "Non-Veg"}
// // //                             </span>
// // //                         </label>
// // //                     </div>
// // //                 </div>
// // //             </div>

// // //             <div className="offers-containers" style={{
// // //                 display: 'grid',
// // //                 gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
// // //                 gap: '20px',
// // //                 padding: '20px',
// // //                 marginTop: '7px'
// // //             }}>
// // //                 {filteredDishes.map((item) => (
// // //                     <div key={item.dishId} className="offers-cards" style={{
// // //                         width: '100%',
// // //                         maxWidth: '300px',
// // //                         margin: '0 auto',
// // //                         borderRadius: '10px',
// // //                         overflow: 'hidden',
// // //                         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
// // //                     }}>
// // //                         <div className="inner-box" style={{ position: 'relative' }}>
// // //                             {/* <div
// // //                                 style={{
// // //                                     position: 'absolute',
// // //                                     top: '5px',
// // //                                     left: '8%',
// // //                                     transform: 'translateX(-50%)',
// // //                                     height: '33px',
// // //                                     width: '33px',
// // //                                     backgroundColor: 'rgb(253 1 0)',
// // //                                     color: '#fff',
// // //                                     borderRadius: '10px',
// // //                                     display: 'flex',
// // //                                     alignItems: 'center',
// // //                                     justifyContent: 'center',
// // //                                     fontWeight: 'bold',
// // //                                     fontSize: '12px',
// // //                                     zIndex: 1
// // //                                 }}
// // //                             >
// // //                                 10%
// // //                             </div> */}

// // //                             {item.dishImage ? (
// // //                                 <img
// // //                                     src={item.dishImage}
// // //                                     alt="Dish"
// // //                                     className="offer-image"
// // //                                     style={{ width: '100%', height: '200px', objectFit: 'cover' }}
// // //                                 />
// // //                             ) : (
// // //                                 <img
// // //                                     src="default-image.jpg"
// // //                                     alt="Default"
// // //                                     className="offer-image"
// // //                                     style={{ width: '100%', height: '200px', objectFit: 'cover' }}
// // //                                 />
// // //                             )}
// // //                         </div>

// // //                         <div
// // //                             className="card-body"
// // //                             style={{
// // //                                 marginTop: '8px',
// // //                                 padding: '15px',
// // //                                 borderRadius: '10px',
// // //                                 backgroundColor: '#fff',
// // //                             }}
// // //                         >
// // //                             <h5 className="card-title text-dark text-center" style={{ fontSize: '20px', marginBottom: '10px' }}>
// // //                                 {item.dishName}
// // //                             </h5>
// // //                             <span className="d-flex justify-content-between" style={{ color: 'black' }}>
// // //                                 <span>
// // //                                     <span style={{ position: 'relative', fontSize: '21px', color: "gray" }}>
// // //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '15px' }}></i>
// // //                                         {item.price}
// // //                                         <span style={{
// // //                                             content: '',
// // //                                             position: 'absolute',
// // //                                             top: '15px',
// // //                                             left: 0,
// // //                                             width: '100%',
// // //                                             borderTop: '1px solid black',
// // //                                         }} />
// // //                                     </span>

// // //                                     <span style={{ fontSize: '20px', position: 'relative', marginLeft: '15px' }}>
// // //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "15px" }}></i>
// // //                                         {item.effectivePrice
// // //                                         }
// // //                                     </span>
// // //                                 </span>

// // //                             </span>

// // //                             <br></br>


// // //                             {cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
// // //                                 // Show increment/decrement if in cart OR just added
// // //                                 <div
// // //                                     className="d-flex justify-content-between align-items-center border p-2 mt-2"
// // //                                     style={{
// // //                                         borderRadius: '50px',
// // //                                         backgroundColor: '#b15dc6',
// // //                                         width: '80%',
// // //                                         height: '37px',
// // //                                         marginLeft: 'auto',
// // //                                         marginRight: 'auto',
// // //                                     }}
// // //                                 >
// // //                                     <button
// // //                                         onClick={() => decreaseQuantity(item.dishId)}
// // //                                         style={{
// // //                                             width: '40px',
// // //                                             height: '40px',
// // //                                             fontSize: '25px',
// // //                                             fontWeight: 'bold',
// // //                                             color: '#fff',
// // //                                             marginTop: '-10px',
// // //                                             border: 'none',
// // //                                             background: 'none',
// // //                                             cursor: 'pointer',
// // //                                         }}
// // //                                     >
// // //                                         -
// // //                                     </button>
// // //                                     <span
// // //                                         style={{
// // //                                             fontSize: '25px',
// // //                                             fontWeight: 'bold',
// // //                                             minWidth: '40px',
// // //                                             textAlign: 'center',
// // //                                             color: '#fff',
// // //                                         }}
// // //                                     >
// // //                                         {quantities[item.dishId] || 1}
// // //                                     </span>
// // //                                     <button
// // //                                         onClick={() => increaseQuantity(item.dishId)}
// // //                                         style={{
// // //                                             width: '40px',
// // //                                             height: '40px',
// // //                                             fontSize: '25px',
// // //                                             fontWeight: 'bold',
// // //                                             color: '#fff',
// // //                                             marginTop: '-10px',
// // //                                             border: 'none',
// // //                                             background: 'none',
// // //                                             cursor: 'pointer',
// // //                                         }}
// // //                                     >
// // //                                         +
// // //                                     </button>
// // //                                 </div>
// // //                             ) : (
// // //                                 // Add To Cart button
// // //                                 <button
// // //                                     className="btn mt-2 d-block mx-auto"
// // //                                     onClick={async () => {
// // //                                         // Immediately set quantity in UI
// // //                                         setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));

// // //                                         // Call addToCart and refresh cartData
// // //                                         await addToCart(item, 1);
// // //                                     }}
// // //                                     style={{
// // //                                         background: "#b15dc6",
// // //                                         color: "#fff",
// // //                                         width: "80%",
// // //                                         borderRadius: "50px",
// // //                                         padding: "8px 0",
// // //                                     }}
// // //                                 >
// // //                                     Add To Cart
// // //                                 </button>
// // //                             )}
// // //                         </div>
// // //                     </div>
// // //                 ))}
// // //             </div>

// // //             <Modal
// // //                 isOpen={isModalOpen}
// // //                 onRequestClose={() => setIsModalOpen(false)}
// // //                 contentLabel="Add to Cart"
// // //                 shouldCloseOnOverlayClick={false}
// // //                 shouldCloseOnEsc={false}
// // //                 style={{
// // //                     overlay: {
// // //                         backgroundColor: "transparent",
// // //                         pointerEvents: "none",
// // //                     },
// // //                     content: {
// // //                         pointerEvents: "auto",
// // //                         position: "sticky",
// // //                         bottom: "20px",
// // //                         top: "620px",
// // //                         left: "30%",
// // //                         width: "90%",
// // //                         maxWidth: "500px",
// // //                         border: "none",
// // //                         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
// // //                         padding: "10px",
// // //                         height: "auto",
// // //                         borderRadius: "10px",
// // //                     },
// // //                 }}
// // //                 onMouseEnter={() => setIsHovered(true)}
// // //                 onMouseLeave={() => setIsHovered(false)}
// // //             >
// // //                 <div
// // //                     style={{
// // //                         display: "flex",
// // //                         alignItems: "center",
// // //                         justifyContent: "space-between",
// // //                         padding: "10px",
// // //                         width: "100%",
// // //                         fontWeight: "bold",
// // //                         color: "#333",
// // //                         borderRadius: "10px",
// // //                         height: "auto",
// // //                         border: "2px solid #b15cd6",
// // //                         flexWrap: "wrap"
// // //                     }}
// // //                 >
// // //                     <ShoppingCart style={{ fontSize: "30px", color: "#b15dc6", marginRight: "10px" }} />

// // //                     {/* Total Items */}
// // //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// // //                         ({cartData.cartItems?.reduce((acc, item) => acc + (quantities[item.dishId] || item.quantity || 0), 0)}) Items
// // //                     </div>

// // //                     {/* Total Price */}
// // //                     {/* Total Price */}
// // //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// // //                         Total: ₹
// // //                         {cartData.cartItems
// // //                             ?.reduce((acc, item) => {
// // //                                 // Get quantity: use quantities state if available, otherwise API quantity
// // //                                 const quantity = quantities[item.dishId] ?? item.quantity ?? 0;

// // //                                 // Get price: parseFloat safely, fallback to 0
// // //                                 const price = parseFloat(item.effectivePrice ?? item.price ?? 0);

// // //                                 return acc + price * quantity;
// // //                             }, 0)
// // //                             .toFixed(2)}
// // //                     </div>


// // //                     <button
// // //                         style={{
// // //                             borderRadius: "50px",
// // //                             background: "#b15dc6",
// // //                             color: "#fff",
// // //                             padding: "8px 16px",
// // //                             border: "none",
// // //                             cursor: "pointer",
// // //                             marginTop: "5px",
// // //                             width: "100%",
// // //                             maxWidth: "150px"
// // //                         }}
// // //                         onClick={handleViewCartClick}
// // //                     >
// // //                         View Cart
// // //                     </button>
// // //                 </div>
// // //             </Modal>
// // //         </div>
// // //     );
// // // };

// // // export default WaitermenuIteams;



// // import React, { useEffect, useState } from 'react';
// // import Modal from 'react-modal';
// // import { ShoppingCart } from '@mui/icons-material';
// // import { useNavigate } from 'react-router-dom';
// // import axios from 'axios';

// // Modal.setAppElement('#root');
// // const WaitermenuIteams = ({ parentId }) => {
// //     const [dishes, setDishes] = useState([]);
// //     const [filteredDishes, setFilteredDishes] = useState([]);
// //     const [quantities, setQuantities] = useState({});
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);
// //     const [isVegSelected, setIsVegSelected] = useState(false);
// //     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
// //     const [isModalOpen, setIsModalOpen] = useState(false);
// //     const [selectedDish, setSelectedDish] = useState(null);
// //     const [cartItems, setCartItems] = useState([]);
// //     const [isHovered, setIsHovered] = useState(false);
// //     const navigate = useNavigate();
// //     const [cartData, setCartData] = useState({ cartItems: [] });
// //     const [refresh, setRefresh] = useState(false);
// //     const [searchQuery, setSearchQuery] = useState("");
    
// //     // Add order type state
// //     const [selectedOrderType, setSelectedOrderType] = useState("DINE_IN");
// //     const [isAllSelected, setIsAllSelected] = useState(true);

// //     const handleSearch = () => {
// //         if (!searchQuery.trim()) {
// //             applyCurrentFilters();
// //             return;
// //         }

// //         const searchTerm = searchQuery.toLowerCase().trim();
// //         const searchResults = dishes.filter(dish =>
// //             dish.dishName.toLowerCase().includes(searchTerm)
// //         );

// //         if (searchResults.length > 0) {
// //             setFilteredDishes(searchResults);
// //         } else {
// //             setFilteredDishes([]);
// //         }
// //     };

// //     useEffect(() => {
// //         handleSearch();
// //     }, [searchQuery, dishes]);

// //     useEffect(() => {
// //         const handleCartUpdate = () => {
// //             setRefresh(prev => prev + 1);
// //         };

// //         window.addEventListener('cartUpdated', handleCartUpdate);
// //         return () => {
// //             window.removeEventListener('cartUpdated', handleCartUpdate);
// //         };
// //     }, []);

// //     const applyCurrentFilters = () => {
// //         let filtered = dishes;

// //         if (isVegSelected) {
// //             filtered = filtered.filter(dish => dish.tag === 'Veg');
// //         } else if (isNonVegSelected) {
// //             filtered = filtered.filter(dish => dish.tag === 'Non_Veg');
// //         }

// //         setFilteredDishes(filtered);
// //     };

// //     const handleFilterClick = (type) => {
// //         if (type === 'Veg') {
// //             setIsVegSelected(true);
// //             setIsNonVegSelected(false);
// //             setIsAllSelected(false);
// //             applyFilter('Veg');
// //         } else if (type === 'Non-Veg') {
// //             setIsVegSelected(false);
// //             setIsNonVegSelected(true);
// //             setIsAllSelected(false);
// //             applyFilter('Non_Veg');
// //         } else {
// //             setIsVegSelected(false);
// //             setIsNonVegSelected(false);
// //             setIsAllSelected(true);
// //             setFilteredDishes(dishes);
// //         }
// //     };

// //     useEffect(() => {
// //         if (dishes.length > 0) {
// //             if (isVegSelected) {
// //                 applyFilter('Veg');
// //             } else if (isNonVegSelected) {
// //                 applyFilter('Non_Veg');
// //             } else {
// //                 setFilteredDishes(dishes);
// //             }
// //         }
// //     }, [dishes, isVegSelected, isNonVegSelected]);

// //     const authToken = localStorage.getItem("authToken");
// //     const vendorId = localStorage.getItem("vendorId");

// //     const triggerCartRefresh = () => {
// //         const event = new CustomEvent('cartUpdated');
// //         window.dispatchEvent(event);
// //     }

// //     const fetchCartData = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const seatingId = localStorage.getItem("seatingId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId || !seatingId || !authToken) return;

// //         try {
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
// //                 { headers: { Authorization: `Bearer ${authToken}` } }
// //             );
            
// //             setCartData(response.data);

// //             const initialQuantities = {};
// //             if (response.data.cartItems) {
// //                 response.data.cartItems.forEach(item => {
// //                     initialQuantities[item.dishId] = item.quantity;
// //                 });
// //             }
// //             setQuantities(initialQuantities);
// //         } catch (err) {
// //             console.error("Error fetching cart:", err);
// //         }
// //     };

// //     const increaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const seatingId = localStorage.getItem("seatingId");
// //         const tableCode = localStorage.getItem("tableCode");

// //         if (!token || !vendorId || !seatingId || !tableCode) {
// //             alert("Missing required data");
// //             return;
// //         }

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) {
// //             alert("Item not found in cart. Please add it first.");
// //             return;
// //         }

// //         const newQty = (quantities[dishId] || 0) + 1;

// //         try {
// //             // Use waiter order API for increment
// //             const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
// //             const data = [{ dishId: dishId, quantity: newQty }];

// //             const response = await axios.post(apiUrl, data, {
// //                 headers: {
// //                     'Content-Type': 'application/json',
// //                     'Authorization': `Bearer ${token}`,
// //                 },
// //             });

// //             if (response.status === 200) {
// //                 setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// //                 await fetchCartData();
// //                 triggerCartRefresh();
// //                 setIsModalOpen(true);
// //                 setTimeout(() => {
// //                     if (!isHovered) setIsModalOpen(false);
// //                 }, 2000);
// //             }
// //         } catch (err) {
// //             console.error("API Error:", err.response ? err.response.data : err);
// //             alert("Unable to update quantity");
// //         }
// //     };

// //     const decreaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const seatingId = localStorage.getItem("seatingId");
// //         const tableCode = localStorage.getItem("tableCode");
        
// //         const currentQty = quantities[dishId] || 0;
// //         if (currentQty === 0) return;

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) return alert("Item not found");

// //         const newQty = currentQty - 1;

// //         if (newQty === 0) {
// //             // Remove item from cart
// //             try {
// //                 const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
// //                 const data = [{ dishId: dishId, quantity: 0 }];

// //                 await axios.post(apiUrl, data, {
// //                     headers: {
// //                         'Content-Type': 'application/json',
// //                         'Authorization': `Bearer ${token}`,
// //                     },
// //                 });

// //                 setQuantities(prev => ({ ...prev, [dishId]: 0 }));
// //                 await fetchCartData();
// //                 triggerCartRefresh();
// //             } catch (err) {
// //                 console.error("Error removing item:", err);
// //             }
// //             return;
// //         }

// //         // Update quantity
// //         try {
// //             const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
// //             const data = [{ dishId: dishId, quantity: newQty }];

// //             await axios.post(apiUrl, data, {
// //                 headers: {
// //                     'Content-Type': 'application/json',
// //                     'Authorization': `Bearer ${token}`,
// //                 },
// //             });

// //             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// //             await fetchCartData();
// //             triggerCartRefresh();
// //         } catch (err) {
// //             console.error("Error updating quantity:", err);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchCartData();
// //     }, [authToken, vendorId, refresh]);

// //     const handleOrderTypeChange = async (type) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId || !token) {
// //             alert("Vendor not logged in!");
// //             return;
// //         }

// //         try {
// //             const orderTypeValue = type === "Dine In" ? "DINE_IN" : "TAKEAWAY";

// //             await axios.put(
// //                 `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
// //                 {},
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             setSelectedOrderType(type);
// //             await fetchCartData();
// //             triggerCartRefresh();

// //         } catch (error) {
// //             console.error("❌ Error updating order type:", error);
// //             alert("Failed to update order type. Please add items to cart first and try again.");
// //         }
// //     };

// //     const addToCart = async (item, quantity = 1) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");
// //         const seatingId = localStorage.getItem("seatingId");
// //         const tableCode = localStorage.getItem("tableCode");

// //         if (!seatingId || !tableCode) {
// //             console.error("❌ Seating ID or Table Code not found in localStorage");
// //             return;
// //         }

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
// //         const data = [{ dishId: item.dishId, quantity }];

// //         try {
// //             const response = await axios.post(apiUrl, data, {
// //                 headers: {
// //                     'Content-Type': 'application/json',
// //                     'Authorization': `Bearer ${token}`,
// //                 },
// //             });

// //             if (response.status === 200) {
// //                 await fetchCartData();
// //                 triggerCartRefresh();
// //                 setIsModalOpen(true);
// //                 setTimeout(() => {
// //                     if (!isHovered) setIsModalOpen(false);
// //                 }, 2000);
// //             } else {
// //                 alert('Failed to add item to cart');
// //             }
// //         } catch (error) {
// //             console.error('Error adding item to cart:', error);
// //             if (error.response) {
// //                 if (error.response.status === 500) alert('Server Error. Please try again later.');
// //                 else if (error.response.status === 404) alert('Item not found. Please try again.');
// //                 else alert(`Error: ${error.response.data}`);
// //             } else {
// //                 alert('An unexpected error occurred. Please try again.');
// //             }
// //         }
// //     };

// //     useEffect(() => {
// //         const fetchData = async () => {
// //             const vendorId = localStorage.getItem("vendorId");
// //             const token = localStorage.getItem("authToken");

// //             if (!vendorId) {
// //                 console.warn("⚠️ vendorId not found in localStorage");
// //                 setError(new Error("vendorId missing"));
// //                 setLoading(false);
// //                 return;
// //             }

// //             if (!token) {
// //                 console.warn("⚠️ authToken not found in localStorage");
// //                 setError(new Error("authToken missing"));
// //                 setLoading(false);
// //                 return;
// //             }

// //             try {
// //                 const response = await fetch(
// //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                     {
// //                         headers: {
// //                             'Authorization': `Bearer ${token}`,
// //                             'Content-Type': 'application/json',
// //                             'Accept': 'application/json',
// //                         },
// //                     }
// //                 );

// //                 if (!response.ok) {
// //                     throw new Error(`HTTP error! status: ${response.status}`);
// //                 }

// //                 const data = await response.json();
// //                 const dishData = Array.isArray(data) ? data : data.data || [];
// //                 const validDishData = dishData.filter(item => item !== null && item !== undefined);

// //                 const filteredData = validDishData.filter(item => {
// //                     const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
// //                     const statusCheck = item.menuStatus === "Enable";
// //                     const quantityCheck = Number(item.balanceQuantity) > 0;
// //                     return parentCheck && statusCheck && quantityCheck;
// //                 });

// //                 setDishes(filteredData);
// //                 setFilteredDishes(filteredData);
// //             } catch (error) {
// //                 console.error('Error fetching data:', error);
// //                 setError(error);
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchData();
// //     }, [parentId]);

// //     // Global search hotkey functionality
// //     useEffect(() => {
// //         const handleGlobalKeyDown = (e) => {
// //             const isTypingInInput =
// //                 e.target.tagName === 'INPUT' ||
// //                 e.target.tagName === 'TEXTAREA' ||
// //                 e.target.isContentEditable;

// //             if (e.key === '/' && !isTypingInInput) {
// //                 e.preventDefault();
// //                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
// //                 if (searchInput) {
// //                     searchInput.focus();
// //                     searchInput.select();
// //                 }
// //             }

// //             const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]:focus');
// //             if (searchInput && !isTypingInInput) {
// //                 if (e.key === 'Backspace') {
// //                     e.preventDefault();
// //                     setSearchQuery(prev => prev.slice(0, -1));
// //                 }
// //                 else if (e.key === 'Escape') {
// //                     e.preventDefault();
// //                     searchInput.blur();
// //                     setSearchQuery("");
// //                 }
// //             }

// //             if (!isTypingInInput &&
// //                 e.key.length === 1 &&
// //                 !e.ctrlKey &&
// //                 !e.metaKey &&
// //                 !e.altKey &&
// //                 e.key !== ' ') {

// //                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');

// //                 if (searchInput) {
// //                     if (document.activeElement !== searchInput) {
// //                         e.preventDefault();
// //                         searchInput.focus();
// //                         setSearchQuery(e.key);
// //                     }
// //                 }
// //             }
// //         };

// //         window.addEventListener('keydown', handleGlobalKeyDown);
// //         return () => {
// //             window.removeEventListener('keydown', handleGlobalKeyDown);
// //         };
// //     }, [searchQuery]);

// //     const applyFilter = (filterType) => {
// //         let filtered = dishes;

// //         if (filterType === 'Veg') {
// //             filtered = dishes.filter(dish => dish.tag === 'Veg');
// //         } else if (filterType === 'Non_Veg') {
// //             filtered = dishes.filter(dish => dish.tag === 'Non_Veg');
// //         }

// //         if (searchQuery.trim()) {
// //             const searchTerm = searchQuery.toLowerCase().trim();
// //             filtered = filtered.filter(dish =>
// //                 dish.dishName.toLowerCase().includes(searchTerm)
// //             );
// //         }

// //         setFilteredDishes(filtered);
// //     };

// //     const separateInStockAndOutOfStock = (items) => {
// //         const inStock = [];
// //         const outOfStock = [];

// //         items.forEach(item => {
// //             const quantity = Number(item.balanceQuantity) || 0;
// //             if (quantity > 0) {
// //                 inStock.push(item);
// //             } else {
// //                 outOfStock.push(item);
// //             }
// //         });

// //         return { inStock, outOfStock };
// //     };

// //     if (loading) {
// //         return <div>Loading...</div>;
// //     }

// //     if (error) {
// //         return <div>Error loading dishes: {error.message}</div>;
// //     }

// //     const { inStock, outOfStock } = separateInStockAndOutOfStock(filteredDishes);
// //     const allItems = [...inStock, ...outOfStock];

// //     return (
// //         <div style={{ marginTop: '100px' }} className='menuiteams-data'>
// //             <div
// //                 style={{
// //                     display: "flex",
// //                     flexWrap: "wrap",
// //                     gap: "1rem",
// //                     marginBottom: "1rem",
// //                     justifyContent: "space-between",
// //                     alignItems: "center",
// //                     padding: "0rem"
// //                 }}
// //             >
// //                 <style>
// //                     {`
// //                         @media (max-width: 768px) {
// //                             .offers-containers {
// //                                 grid-template-columns: repeat(2, 1fr) !important;
// //                                 gap: 15px !important;
// //                             }
// //                             .offers-cards {
// //                                 width: 100% !important;
// //                                 max-width: 100% !important;
// //                             }
// //                             .responsive-button-group {
// //                                 flex-direction: column !important;
// //                                 align-items: center !important;
// //                                 width:90vw !important;
// //                             }
// //                             .responsive-button {
// //                                 width: 25% !important;
// //                                 text-align: center;
// //                             }
// //                             .custom-switch-wrapper {
// //                                 margin-top: 10px;
// //                            left: "-20px"
// //                             }
// //                         }
                        
// //                         @media (max-width: 480px) {
// //                             .offers-containers {
// //                                 grid-template-columns: 1fr !important;
// //                             }
// //                             .offers-cards {
// //                                 margin: 0 auto !important;
// //                             }
// //                             .card-body {
// //                                 padding: 10px !important;
// //                             }
// //                             .card-title {
// //                                 font-size: 18px !important;
// //                             }
// //                         }
                        
// //                         @media (max-width: 320px) {
// //                             .offers-cards {
// //                                 width: 95% !important;
// //                             }
// //                             .card-body {
// //                                 padding: 8px !important;
// //                             }
// //                             .card-title {
// //                                 font-size: 16px !important;
// //                             }
// //                         }
                        
// //                         .custom-switch {
// //                             position: relative;
// //                             display: inline-block;
// //                             width: 100px;
// //                             height: 35px;
// //                         }
                        
// //                         .custom-switch input {
// //                             opacity: 0;
// //                             width: 0;
// //                             height: 0;
// //                         }
                        
// //                         .custom-slideryy {
// //                             position: absolute;
// //                             cursor: pointer;
// //                             transition: 0.4s;
// //                             font-weight: bold;
// //                             font-size: 14px;
// //                             color: #000;
// //                             text-align: center;
// //                             line-height: 35px;
// //                             width: 100px;
// //                             height: 40px;
// //                             border-radius: 5px;
// //                             background-color: rgb(217, 217, 217);
// //                         }
                        
// //                         .custom-slideryy::before {
// //                             content: "";
// //                             position: absolute;
// //                             height: 16px;
// //                             width: 16px;
// //                             left: 8px;
// //                             top: 13px;
// //                             background-color: #000;
// //                             transition: 0.4s;
// //                             border-radius: 50%;
// //                         }
                        
// //                         .custom-slideryy.veg::before {
// //                             background-color: green;
// //                         }
                        
// //                         .custom-slideryy.non-veg::before {
// //                             background-color: red;
// //                         }
                        
// //                         .custom-switch input:checked + .custom-slideryy::before {
// //                             transform: translateX(60px);
// //                         }
// //                     `}
// //                 </style>

// //                 <div
// //                     className="responsive-button-group menu-responsive-buttons-code"
// //                     style={{
// //                         display: "flex",
// //                         flexDirection: "column",
// //                         justifyContent: "start",
// //                         alignItems: window.innerWidth < 768 ? "flex-start" : "start",
// //                         marginLeft: window.innerWidth < 768 ? "0" : "15px",
// //                         width: "100%",
// //                         gap: "10px",
// //                         marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : window.innerWidth < 768 ? "-25" : "-17px",
// //                     }}
// //                 >
                    

// //                     {/* Bottom Section - Controls */}
// //                     <div style={{
// //                         display: "flex",
// //                         flexDirection: window.innerWidth < 1400 ? "column" : "row",
// //                         gap: window.innerWidth < 1400 ? "8px" : "10px",
// //                         alignItems: "stretch",
// //                         width: "100%",
// //                     }}>

// //                         {/* Search Bar */}
// //                         <div style={{
// //                             display: "flex",
// //                             justifyContent: window.innerWidth < 1400 ? "flex-end" : "flex-end",
// //                             alignItems: "center",
// //                             width: "100%",
// //                             order: window.innerWidth < 1400 ? 1 : 2,
// //                         }}>
// //                             <div style={{
// //                                 position: "relative",
// //                                 display: "flex",
// //                                 alignItems: "center",
// //                                 width: window.innerWidth < 1400 ?
// //                                     (window.innerWidth < 400 ? "100%" : window.innerWidth < 430 ? "97%" :
// //                                         window.innerWidth < 768 ? "95%" :
// //                                             window.innerWidth < 1200 ? "85%" : "80%") :
// //                                     (window.innerWidth < 400 ? "100%" :
// //                                         window.innerWidth < 768 ? "95%" :
// //                                             "180px"),
// //                                 maxWidth: window.innerWidth < 430 ? " " : window.innerWidth < 1400 ? "300px" : "280px",
// //                                 marginLeft: window.innerWidth < 1400 ? "auto" : "0",
// //                             }}>
// //                                 <input
// //                                     type="text"
// //                                     placeholder="Search dishes..."
// //                                     value={searchQuery}
// //                                     onChange={(e) => setSearchQuery(e.target.value)}
// //                                     onKeyPress={(e) => {
// //                                         if (e.key === 'Enter') {
// //                                             handleSearch();
// //                                         }
// //                                     }}
// //                                     style={{
// //                                         width: "100%",
// //                                         padding: window.innerWidth < 400 ? "6px 30px 6px 10px" :
// //                                             window.innerWidth < 768 ? "7px 32px 7px 10px" :
// //                                                 "8px 35px 8px 12px",
// //                                         borderRadius: "20px",
// //                                         border: "2px solid #b15cd6",
// //                                         fontSize: window.innerWidth < 400 ? "12px" :
// //                                             window.innerWidth < 768 ? "12px" :
// //                                                 window.innerWidth < 1200 ? "12px" : "13px",
// //                                         outline: "none",
// //                                         transition: "all 0.3s ease",
// //                                         backgroundColor: "#fff",
// //                                         height: window.innerWidth < 400 ? "32px" :
// //                                             window.innerWidth < 768 ? "33px" : "35px",
// //                                     }}
// //                                 />
// //                                 <button
// //                                     onClick={handleSearch}
// //                                     style={{
// //                                         position: "absolute",
// //                                         right: window.innerWidth < 400 ? "5px" : "6px",
// //                                         background: "transparent",
// //                                         border: "none",
// //                                         cursor: "pointer",
// //                                         padding: "4px",
// //                                         display: "flex",
// //                                         alignItems: "center",
// //                                         justifyContent: "center"
// //                                     }}
// //                                 >
// //                                     <svg
// //                                         width={window.innerWidth < 400 ? "14" :
// //                                             window.innerWidth < 768 ? "15" :
// //                                                 window.innerWidth < 1200 ? "16" : "18"}
// //                                         height={window.innerWidth < 400 ? "14" :
// //                                             window.innerWidth < 768 ? "15" :
// //                                                 window.innerWidth < 1200 ? "16" : "18"}
// //                                         viewBox="0 0 24 24"
// //                                         fill="none"
// //                                         stroke="#b15cd6"
// //                                         strokeWidth="2"
// //                                     >
// //                                         <circle cx="11" cy="11" r="8" />
// //                                         <path d="m21 21-4.3-4.3" />
// //                                     </svg>
// //                                 </button>
// //                             </div>
// //                         </div>

// //                         {/* Filter Buttons and Order Type */}
// //                         <div style={{
// //                             display: "flex",
// //                             flexDirection: window.innerWidth < 1400 ? "row" : "row",
// //                             gap: window.innerWidth < 1400 ?
// //                                 (window.innerWidth < 400 ? "8px" :
// //                                     window.innerWidth < 768 ? "10px" : "15px") :
// //                                 (window.innerWidth < 400 ? "8px" :
// //                                     window.innerWidth < 768 ? "10px" : "15px"),
// //                             alignItems: "center",
// //                             justifyContent: window.innerWidth < 1400 ? "space-between" : "flex-start",
// //                             width: "100%",
// //                             order: window.innerWidth < 1400 ? 2 : 1,
// //                             flexWrap: window.innerWidth < 1400 ? "wrap" : "nowrap",
// //                         }}>

// //                             {/* Veg/Non-Veg Buttons */}
// //                             <div
// //                                 className="veg-nonveg-buttons"
// //                                 style={{
// //                                     display: "flex",
// //                                     gap: "10px",
// //                                     justifyContent: "center",
// //                                     alignItems: "center",
// //                                     flexShrink: 0,
// //                                 }}
// //                             >
// //                                 <button
// //                                     onClick={() => handleFilterClick("Veg")}
// //                                     style={{
// //                                         padding: window.innerWidth < 400 ? "4px 10px" :
// //                                             window.innerWidth < 768 ? "4px 8px" : "4px 10px",
// //                                         backgroundColor: isVegSelected ? "#4CAF50" : "#f0f0f0",
// //                                         color: isVegSelected ? "white" : "#666",
// //                                         border: isVegSelected ? "2px solid #4CAF50" : "2px solid #ddd",
// //                                         borderRadius: "20px",
// //                                         fontSize: window.innerWidth < 400 ? "12px" :
// //                                             window.innerWidth < 768 ? "14px" : "14px",
// //                                         fontWeight: "bold",
// //                                         cursor: "pointer",
// //                                         transition: "all 0.3s ease",
// //                                         display: "flex",
// //                                         alignItems: "center",
// //                                         gap: "5px",
// //                                         whiteSpace: "nowrap",
// //                                         minWidth: window.innerWidth < 400 ? "60px" : "70px",
// //                                         justifyContent: "center"
// //                                     }}
// //                                 >
// //                                     <span style={{
// //                                         width: "12px",
// //                                         height: "12px",
// //                                         backgroundColor: "#4CAF50",
// //                                         borderRadius: "50%",
// //                                         display: "inline-block",
// //                                         border: isVegSelected ? "1px solid white" : "1px solid #4CAF50"
// //                                     }}></span>
// //                                     Veg
// //                                 </button>

// //                                 <button
// //                                     onClick={() => handleFilterClick("Non-Veg")}
// //                                     style={{
// //                                         padding: window.innerWidth < 400 ? "4px 10px" :
// //                                             window.innerWidth < 768 ? "4px 8px" : "4px 10px",
// //                                         backgroundColor: isNonVegSelected ? "#f44336" : "#f0f0f0",
// //                                         color: isNonVegSelected ? "white" : "#666",
// //                                         border: isNonVegSelected ? "2px solid #f44336" : "2px solid #ddd",
// //                                         borderRadius: "20px",
// //                                         fontSize: window.innerWidth < 400 ? "12px" :
// //                                             window.innerWidth < 768 ? "14px" : "14px",
// //                                         fontWeight: "bold",
// //                                         cursor: "pointer",
// //                                         transition: "all 0.3s ease",
// //                                         display: "flex",
// //                                         alignItems: "center",
// //                                         gap: "5px",
// //                                         whiteSpace: "nowrap",
// //                                         minWidth: window.innerWidth < 400 ? "75px" : "85px",
// //                                         justifyContent: "center"
// //                                     }}
// //                                 >
// //                                     <span style={{
// //                                         width: "12px",
// //                                         height: "12px",
// //                                         backgroundColor: "#f44336",
// //                                         borderRadius: "50%",
// //                                         display: "inline-block",
// //                                         border: isNonVegSelected ? "1px solid white" : "1px solid #f44336"
// //                                     }}></span>
// //                                     Non-Veg
// //                                 </button>
// //                             </div>

                
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Card Grid */}
// //             <div className="offers-containers" style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
// //                 gap: '1rem',
// //                 padding: '1rem 1rem 7rem 1rem',
// //                 justifyItems: 'center'
// //             }}>
// //                 {allItems.length > 0 ? (
// //                     allItems.map((item) => {
// //                         const quantity = Number(item.balanceQuantity) || 0;
// //                         const isOutOfStock = quantity <= 0;

// //                         return (
// //                             <div
// //                                 key={item.dishId}
// //                                 className="offers-cards"
// //                                 style={{
// //                                     width: '100%',
// //                                     maxWidth: '180px',
// //                                     borderRadius: '0.75rem',
// //                                     overflow: 'hidden',
// //                                     boxShadow: isOutOfStock
// //                                         ? '0 2px 8px rgba(0, 0, 0, 0.1)'
// //                                         : '0 4px 12px rgba(0, 0, 0, 0.1)',
// //                                     background: isOutOfStock ? '#f8f9fa' : 'white',
// //                                     transition: 'all 0.3s ease',
// //                                     border: isOutOfStock
// //                                         ? '1px solid #e0e0e0'
// //                                         : '1px solid #f0f0f0',
// //                                     display: 'flex',
// //                                     flexDirection: 'column',
// //                                     height: '100%',
// //                                     opacity: isOutOfStock ? 0.7 : 1,
// //                                     position: 'relative'
// //                                 }}
// //                             >
// //                                 <div style={{
// //                                     padding: '0.75rem',
// //                                     display: 'flex',
// //                                     flexDirection: 'column',
// //                                     flexGrow: 1,
// //                                     position: 'relative',
// //                                     zIndex: 2
// //                                 }}>
// //                                     <div style={{
// //                                         display: "flex",
// //                                         alignItems: "flex-start",
// //                                         justifyContent: "space-between",
// //                                         marginBottom: "0.5rem"
// //                                     }}>
// //                                         <h5 style={{
// //                                             fontSize: "1rem",
// //                                             margin: 0,
// //                                             fontWeight: "600",
// //                                             color: isOutOfStock ? "#888" : "#333",
// //                                             lineHeight: "1.2",
// //                                             flex: 1,
// //                                             marginRight: "0.5rem"
// //                                         }}>
// //                                             {item.dishName}
// //                                         </h5>

// //                                         {item.tag === "Veg" ? (
// //                                             <div style={{
// //                                                 width: "12px",
// //                                                 height: "12px",
// //                                                 border: `1.5px solid ${isOutOfStock ? '#888' : 'green'}`,
// //                                                 borderRadius: "2px",
// //                                                 position: "relative",
// //                                                 flexShrink: 0,
// //                                                 marginTop: "0.25rem"
// //                                             }}>
// //                                                 <div style={{
// //                                                     width: "6px",
// //                                                     height: "6px",
// //                                                     backgroundColor: isOutOfStock ? '#888' : 'green',
// //                                                     borderRadius: "50%",
// //                                                     position: "absolute",
// //                                                     top: "50%",
// //                                                     left: "50%",
// //                                                     transform: "translate(-50%, -50%)",
// //                                                 }}></div>
// //                                             </div>
// //                                         ) : (
// //                                             <div style={{
// //                                                 width: "12px",
// //                                                 height: "12px",
// //                                                 border: `1.5px solid ${isOutOfStock ? '#888' : 'red'}`,
// //                                                 borderRadius: "2px",
// //                                                 position: "relative",
// //                                                 flexShrink: 0,
// //                                                 marginTop: "0.25rem"
// //                                             }}>
// //                                                 <div style={{
// //                                                     width: "6px",
// //                                                     height: "6px",
// //                                                     backgroundColor: isOutOfStock ? '#888' : 'red',
// //                                                     borderRadius: "50%",
// //                                                     position: "absolute",
// //                                                     top: "50%",
// //                                                     left: "50%",
// //                                                     transform: "translate(-50%, -50%)",
// //                                                 }}></div>
// //                                             </div>
// //                                         )}
// //                                     </div>

// //                                     <div style={{ flexGrow: 1 }}></div>

// //                                     <div style={{
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         gap: '0.5rem',
// //                                         marginBottom: '0.75rem'
// //                                     }}>
// //                                         {item.price > item.effectivePrice ? (
// //                                             <>
// //                                                 <span style={{
// //                                                     fontSize: '0.8rem',
// //                                                     color: isOutOfStock ? '#aaa' : 'gray',
// //                                                     textDecoration: 'line-through'
// //                                                 }}>
// //                                                     <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '0.7rem' }}></i>
// //                                                     {item.price}
// //                                                 </span>
// //                                                 <span style={{
// //                                                     fontSize: '0.9rem',
// //                                                     fontWeight: 'bold',
// //                                                     color: isOutOfStock ? '#888' : '#333'
// //                                                 }}>
// //                                                     <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
// //                                                     {item.effectivePrice}
// //                                                 </span>
// //                                             </>
// //                                         ) : (
// //                                             <span style={{
// //                                                 fontSize: '0.9rem',
// //                                                 fontWeight: 'bold',
// //                                                 color: isOutOfStock ? '#888' : '#333'
// //                                             }}>
// //                                                 <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
// //                                                 {item.price}
// //                                             </span>
// //                                         )}
// //                                     </div>

// //                                     <div style={{ textAlign: "center" }}>
// //                                         {isOutOfStock ? (
// //                                             <button
// //                                                 disabled
// //                                                 style={{
// //                                                     background: "#cccccc",
// //                                                     color: "#666666",
// //                                                     width: "100%",
// //                                                     borderRadius: "1.5rem",
// //                                                     padding: "0.5rem",
// //                                                     border: "none",
// //                                                     fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
// //                                                     fontWeight: "500",
// //                                                     cursor: "not-allowed",
// //                                                     opacity: 0.6
// //                                                 }}
// //                                             >
// //                                                 Out of Stock
// //                                             </button>
// //                                         ) : cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
// //                                             <div style={{
// //                                                 display: 'flex',
// //                                                 justifyContent: 'space-between',
// //                                                 alignItems: 'center',
// //                                                 background: '#b15dc6',
// //                                                 borderRadius: '1.5rem',
// //                                                 padding: window.innerWidth < 900 ? " " : '0.25rem 0.5rem',
// //                                                 color: 'white'
// //                                             }}>
// //                                                 <button
// //                                                     onClick={() => decreaseQuantity(item.dishId)}
// //                                                     style={{
// //                                                         background: 'none',
// //                                                         border: 'none',
// //                                                         color: 'white',
// //                                                         fontSize: '1rem',
// //                                                         cursor: 'pointer',
// //                                                         padding: '0.25rem'
// //                                                     }}
// //                                                 >
// //                                                     -
// //                                                 </button>
// //                                                 <span style={{
// //                                                     fontSize: '0.9rem',
// //                                                     fontWeight: 'bold',
// //                                                     minWidth: '1.5rem',
// //                                                     textAlign: 'center'
// //                                                 }}>
// //                                                     {quantities[item.dishId] || 1}
// //                                                 </span>
// //                                                 <button
// //                                                     onClick={() => increaseQuantity(item.dishId)}
// //                                                     style={{
// //                                                         background: 'none',
// //                                                         border: 'none',
// //                                                         color: 'white',
// //                                                         fontSize: '1rem',
// //                                                         cursor: 'pointer',
// //                                                         padding: '0.25rem'
// //                                                     }}
// //                                                 >
// //                                                     +
// //                                                 </button>
// //                                             </div>
// //                                         ) : (
// //                                             <button
// //                                                 onClick={async () => {
// //                                                     setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
// //                                                     await addToCart(item, 1);
// //                                                 }}
// //                                                 style={{
// //                                                     background: "#b15dc6",
// //                                                     color: "#fff",
// //                                                     width: "100%",
// //                                                     borderRadius: "1.5rem",
// //                                                     padding: "0.5rem",
// //                                                     border: "none",
// //                                                     fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
// //                                                     fontWeight: "500",
// //                                                     cursor: "pointer"
// //                                                 }}
// //                                             >
// //                                                 Add To Cart
// //                                             </button>
// //                                         )}
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         );
// //                     })
// //                 ) : (
// //                     <div style={{
// //                         gridColumn: "1 / -1",
// //                         textAlign: "center",
// //                         padding: "3rem",
// //                         color: "#666",
// //                         fontSize: "1.1rem",
// //                         width: "100%"
// //                     }}>
// //                         {searchQuery ? `No dishes found matching "${searchQuery}"` : "No dishes available"}
// //                     </div>
// //                 )}
// //             </div>

// //             {/* <Modal
// //                 isOpen={isModalOpen}
// //                 onRequestClose={() => setIsModalOpen(false)}
// //                 contentLabel="Add to Cart"
// //                 shouldCloseOnOverlayClick={false}
// //                 shouldCloseOnEsc={false}
// //                 style={{
// //                     overlay: {
// //                         backgroundColor: "transparent",
// //                         pointerEvents: "none",
// //                     },
// //                     content: {
// //                         pointerEvents: "auto",
// //                         position: "sticky",
// //                         bottom: "20px",
// //                         top: "620px",
// //                         left: "30%",
// //                         width: "90%",
// //                         maxWidth: "500px",
// //                         border: "none",
// //                         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
// //                         padding: "10px",
// //                         height: "auto",
// //                         borderRadius: "10px",
// //                     },
// //                 }}
// //                 onMouseEnter={() => setIsHovered(true)}
// //                 onMouseLeave={() => setIsHovered(false)}
// //             >
// //                 <div
// //                     style={{
// //                         display: "flex",
// //                         alignItems: "center",
// //                         justifyContent: "space-between",
// //                         padding: "10px",
// //                         width: "100%",
// //                         fontWeight: "bold",
// //                         color: "#333",
// //                         borderRadius: "10px",
// //                         height: "auto",
// //                         border: "2px solid #b15cd6",
// //                         flexWrap: "wrap"
// //                     }}
// //                 >
// //                     <ShoppingCart style={{ fontSize: "30px", color: "#b15dc6", marginRight: "10px" }} />

// //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// //                         ({cartData.cartItems?.reduce((acc, item) => acc + (quantities[item.dishId] || item.quantity || 0), 0)}) Items
// //                     </div>

// //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// //                         Total: ₹
// //                         {cartData.cartItems
// //                             ?.reduce((acc, item) => {
// //                                 const quantity = quantities[item.dishId] ?? item.quantity ?? 0;
// //                                 const price = parseFloat(item.effectivePrice ?? item.price ?? 0);
// //                                 return acc + price * quantity;
// //                             }, 0)
// //                             .toFixed(2)}
// //                     </div>

// //                     <button
// //                         style={{
// //                             borderRadius: "50px",
// //                             background: "#b15dc6",
// //                             color: "#fff",
// //                             padding: "8px 16px",
// //                             border: "none",
// //                             cursor: "pointer",
// //                             marginTop: "5px",
// //                             width: "100%",
// //                             maxWidth: "150px"
// //                         }}
// //                         onClick={() => {
// //                             // No navigation needed - cart is already in sidebar
// //                             setIsModalOpen(false);
// //                         }}
// //                     >
// //                         View Cart
// //                     </button>
// //                 </div>
// //             </Modal> */}
// //         </div>
// //     );
// // };

// // export default WaitermenuIteams;




// import React, { useEffect, useState } from 'react';
// import Modal from 'react-modal';
// import { ShoppingCart } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// Modal.setAppElement('#root');
// const WaitermenuIteams = ({ parentId }) => {
//     const [dishes, setDishes] = useState([]);
//     const [filteredDishes, setFilteredDishes] = useState([]);
//     const [quantities, setQuantities] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isVegSelected, setIsVegSelected] = useState(false);
//     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedDish, setSelectedDish] = useState(null);
//     const [cartItems, setCartItems] = useState([]);
//     const [isHovered, setIsHovered] = useState(false);
//     const navigate = useNavigate();
//     const [cartData, setCartData] = useState({ cartItems: [] });
//     const [refresh, setRefresh] = useState(false);
//     const [searchQuery, setSearchQuery] = useState("");
    
//     // Add order type state
//     const [selectedOrderType, setSelectedOrderType] = useState("TABLE_DINE_IN");
//     const [isAllSelected, setIsAllSelected] = useState(true);
    
//     // Add remove confirmation states
//     const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
//     const [itemToRemove, setItemToRemove] = useState(null);

//     const handleSearch = () => {
//         if (!searchQuery.trim()) {
//             applyCurrentFilters();
//             return;
//         }

//         const searchTerm = searchQuery.toLowerCase().trim();
//         const searchResults = dishes.filter(dish =>
//             dish.dishName.toLowerCase().includes(searchTerm)
//         );

//         if (searchResults.length > 0) {
//             setFilteredDishes(searchResults);
//         } else {
//             setFilteredDishes([]);
//         }
//     };

//     useEffect(() => {
//         handleSearch();
//     }, [searchQuery, dishes]);

//     useEffect(() => {
//         const handleCartUpdate = () => {
//             setRefresh(prev => prev + 1);
//         };

//         window.addEventListener('cartUpdated', handleCartUpdate);
//         return () => {
//             window.removeEventListener('cartUpdated', handleCartUpdate);
//         };
//     }, []);

//     const applyCurrentFilters = () => {
//         let filtered = dishes;

//         if (isVegSelected) {
//             filtered = filtered.filter(dish => dish.tag === 'Veg');
//         } else if (isNonVegSelected) {
//             filtered = filtered.filter(dish => dish.tag === 'Non_Veg');
//         }

//         setFilteredDishes(filtered);
//     };

//     const handleFilterClick = (type) => {
//         if (type === 'Veg') {
//             setIsVegSelected(true);
//             setIsNonVegSelected(false);
//             setIsAllSelected(false);
//             applyFilter('Veg');
//         } else if (type === 'Non-Veg') {
//             setIsVegSelected(false);
//             setIsNonVegSelected(true);
//             setIsAllSelected(false);
//             applyFilter('Non_Veg');
//         } else {
//             setIsVegSelected(false);
//             setIsNonVegSelected(false);
//             setIsAllSelected(true);
//             setFilteredDishes(dishes);
//         }
//     };

//     useEffect(() => {
//         if (dishes.length > 0) {
//             if (isVegSelected) {
//                 applyFilter('Veg');
//             } else if (isNonVegSelected) {
//                 applyFilter('Non_Veg');
//             } else {
//                 setFilteredDishes(dishes);
//             }
//         }
//     }, [dishes, isVegSelected, isNonVegSelected]);

//     const authToken = localStorage.getItem("authToken");
//     const vendorId = localStorage.getItem("vendorId");

//     const triggerCartRefresh = () => {
//         const event = new CustomEvent('cartUpdated');
//         window.dispatchEvent(event);
//     }

//     // FIXED: Use the correct API endpoint for table cart
//     const fetchCartData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const seatingId = localStorage.getItem("seatingId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !seatingId || !authToken) {
//             console.log("Missing vendorId, seatingId, or authToken");
//             return;
//         }

//         try {
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
//                 { 
//                     headers: { 
//                         Authorization: `Bearer ${authToken}`,
//                         "Cache-Control": "no-cache"
//                     } 
//                 }
//             );
            
//             if (response.data) {
//                 setCartData(response.data);

//                 const initialQuantities = {};
//                 if (response.data.cartItems) {
//                     response.data.cartItems.forEach(item => {
//                         initialQuantities[item.dishId] = item.quantity;
//                     });
//                 }
//                 setQuantities(initialQuantities);
//             }
//         } catch (err) {
//             console.error("Error fetching cart:", err);
//         }
//     };

//     // FIXED: Use the same API structure as MenuItems but for table
//     const increaseQuantity = async (dishId) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const cartId = localStorage.getItem("cartId");

//         if (!token || !vendorId || !cartId) {
//             alert("Auth token, vendorId, or cartId missing");
//             return;
//         }

//         if (!cartData || !cartData.cartItems) {
//             alert("Cart is empty or not loaded yet.");
//             return;
//         }

//         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
//         if (!cartItem) {
//             alert("Item not found in cart. Please add it first.");
//             return;
//         }

//         const newQty = (quantities[dishId] || 0) + 1;

//         // FIXED: Use the same update endpoint as MenuItems
//         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${dishId}&quantity=${newQty}`;

//         console.log("Increasing quantity - URL:", apiUrl);

//         try {
//             const response = await axios.put(apiUrl, null, {
//                 headers: { 
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });

//             console.log("Increase response:", response.data);

//             // Update local state immediately
//             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
//             setCartData(prev => ({
//                 ...prev,
//                 cartItems: prev.cartItems.map(item =>
//                     item.dishId === dishId ? { ...item, quantity: newQty } : item
//                 )
//             }));

//             // Refresh cart data to get updated totals
//             await fetchCartData();
//             triggerCartRefresh();

//             setIsModalOpen(true);
//             setTimeout(() => {
//                 if (!isHovered) setIsModalOpen(false);
//             }, 2000);
//         } catch (err) {
//             console.error("API Error:", err.response ? err.response.data : err);
//             alert("Unable to update quantity");
//         }
//     };

//     // FIXED: Use the same logic as MenuItems
//     const decreaseQuantity = async (dishId) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const cartId = localStorage.getItem("cartId");
//         const currentQty = quantities[dishId] || 0;
        
//         if (currentQty === 0) return;

//         if (!cartData || !cartData.cartItems) {
//             alert("Cart is empty or not loaded yet.");
//             return;
//         }

//         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
//         if (!cartItem) return alert("Item not found");

//         const newQty = currentQty - 1;

//         // If quantity becomes 0, show confirmation
//         if (newQty === 0) {
//             setItemToRemove({ dishId, cartItem });
//             setShowRemoveConfirm(true);
//             return;
//         }

//         // Otherwise update normally
//         await updateQuantity(dishId, newQty);
//     };

//     // FIXED: Common update function
//     const updateQuantity = async (dishId, newQty) => {
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");
//         const cartId = localStorage.getItem("cartId");

//         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${dishId}&quantity=${newQty}`;

//         try {
//             const response = await axios.put(apiUrl, null, {
//                 headers: { 
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });

//             // Update local state immediately
//             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
//             setCartData(prev => ({
//                 ...prev,
//                 cartItems: newQty > 0
//                     ? prev.cartItems.map(item =>
//                         item.dishId === dishId ? { ...item, quantity: newQty } : item
//                     )
//                     : prev.cartItems.filter(item => item.dishId !== dishId)
//             }));

//             // Refresh cart data to get updated totals
//             await fetchCartData();
//             triggerCartRefresh();

//             setIsModalOpen(true);
//             setTimeout(() => {
//                 if (!isHovered) setIsModalOpen(false);
//             }, 2000);
//         } catch (err) {
//             console.error("API Error:", err.response ? err.response.data : err);
//             alert("Unable to update quantity");
//         }
//     };

//     // FIXED: Confirm remove function
//     const confirmRemove = async () => {
//         if (itemToRemove) {
//             await updateQuantity(itemToRemove.dishId, 0);
//             setShowRemoveConfirm(false);
//             setItemToRemove(null);
//         }
//     };

//     const cancelRemove = () => {
//         setShowRemoveConfirm(false);
//         setItemToRemove(null);
//     };

//     useEffect(() => {
//         fetchCartData();
//     }, [authToken, vendorId, refresh]);

//     const handleOrderTypeChange = async (type) => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) {
//             alert("Vendor not logged in!");
//             return;
//         }

//         try {
//             const orderTypeValue = type === "Dine In" ? "TABLE_DINE_IN" : "TAKEAWAY";

//             await axios.put(
//                 `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
//                 {},
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             setSelectedOrderType(type);
//             await fetchCartData();
//             triggerCartRefresh();

//         } catch (error) {
//             console.error("❌ Error updating order type:", error);
//             alert("Failed to update order type. Please add items to cart first and try again.");
//         }
//     };

//     // FIXED: Use the correct add to cart API for table
//     const addToCart = async (item, quantity = 1) => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");
//         const seatingId = localStorage.getItem("seatingId");
//         const tableCode = localStorage.getItem("tableCode");

//         if (!seatingId || !tableCode) {
//             console.error("❌ Seating ID or Table Code not found in localStorage");
//             alert("Table information missing. Please select a table first.");
//             return;
//         }

//         // FIXED: Use waiter-order endpoint for initial add
//         const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
//         const data = [{ dishId: item.dishId, quantity }];

//         try {
//             const response = await axios.post(apiUrl, data, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`,
//                 },
//             });

//             if (response.status === 200) {
//                 // After adding, fetch the cart data which will include the cartId
//                 await fetchCartData();
//                 triggerCartRefresh();
//                 setIsModalOpen(true);
//                 setTimeout(() => {
//                     if (!isHovered) setIsModalOpen(false);
//                 }, 2000);
//             } else {
//                 alert('Failed to add item to cart');
//             }
//         } catch (error) {
//             console.error('Error adding item to cart:', error);
//             if (error.response) {
//                 alert(`Error: ${error.response.data.message || error.response.statusText}`);
//             } else {
//                 alert('An unexpected error occurred. Please try again.');
//             }
//         }
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!vendorId) {
//                 console.warn("⚠️ vendorId not found in localStorage");
//                 setError(new Error("vendorId missing"));
//                 setLoading(false);
//                 return;
//             }

//             if (!token) {
//                 console.warn("⚠️ authToken not found in localStorage");
//                 setError(new Error("authToken missing"));
//                 setLoading(false);
//                 return;
//             }

//             try {
//                 const response = await fetch(
//                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                     {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Content-Type': 'application/json',
//                             'Accept': 'application/json',
//                         },
//                     }
//                 );

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }

//                 const data = await response.json();
//                 const dishData = Array.isArray(data) ? data : data.data || [];
//                 const validDishData = dishData.filter(item => item !== null && item !== undefined);

//                 const filteredData = validDishData.filter(item => {
//                     const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
//                     const statusCheck = item.menuStatus === "Enable";
//                     const quantityCheck = Number(item.balanceQuantity) > 0;
//                     return parentCheck && statusCheck && quantityCheck;
//                 });

//                 setDishes(filteredData);
//                 setFilteredDishes(filteredData);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//                 setError(error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [parentId]);

//     // Global search hotkey functionality
//     useEffect(() => {
//         const handleGlobalKeyDown = (e) => {
//             const isTypingInInput =
//                 e.target.tagName === 'INPUT' ||
//                 e.target.tagName === 'TEXTAREA' ||
//                 e.target.isContentEditable;

//             if (e.key === '/' && !isTypingInInput) {
//                 e.preventDefault();
//                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
//                 if (searchInput) {
//                     searchInput.focus();
//                     searchInput.select();
//                 }
//             }

//             const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]:focus');
//             if (searchInput && !isTypingInInput) {
//                 if (e.key === 'Backspace') {
//                     e.preventDefault();
//                     setSearchQuery(prev => prev.slice(0, -1));
//                 }
//                 else if (e.key === 'Escape') {
//                     e.preventDefault();
//                     searchInput.blur();
//                     setSearchQuery("");
//                 }
//             }

//             if (!isTypingInInput &&
//                 e.key.length === 1 &&
//                 !e.ctrlKey &&
//                 !e.metaKey &&
//                 !e.altKey &&
//                 e.key !== ' ') {

//                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');

//                 if (searchInput) {
//                     if (document.activeElement !== searchInput) {
//                         e.preventDefault();
//                         searchInput.focus();
//                         setSearchQuery(e.key);
//                     }
//                 }
//             }
//         };

//         window.addEventListener('keydown', handleGlobalKeyDown);
//         return () => {
//             window.removeEventListener('keydown', handleGlobalKeyDown);
//         };
//     }, [searchQuery]);

//     const applyFilter = (filterType) => {
//         let filtered = dishes;

//         if (filterType === 'Veg') {
//             filtered = dishes.filter(dish => dish.tag === 'Veg');
//         } else if (filterType === 'Non_Veg') {
//             filtered = dishes.filter(dish => dish.tag === 'Non_Veg');
//         }

//         if (searchQuery.trim()) {
//             const searchTerm = searchQuery.toLowerCase().trim();
//             filtered = filtered.filter(dish =>
//                 dish.dishName.toLowerCase().includes(searchTerm)
//             );
//         }

//         setFilteredDishes(filtered);
//     };

//     const separateInStockAndOutOfStock = (items) => {
//         const inStock = [];
//         const outOfStock = [];

//         items.forEach(item => {
//             const quantity = Number(item.balanceQuantity) || 0;
//             if (quantity > 0) {
//                 inStock.push(item);
//             } else {
//                 outOfStock.push(item);
//             }
//         });

//         return { inStock, outOfStock };
//     };

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     if (error) {
//         return <div>Error loading dishes: {error.message}</div>;
//     }

//     const { inStock, outOfStock } = separateInStockAndOutOfStock(filteredDishes);
//     const allItems = [...inStock, ...outOfStock];

//     return (
//         <div style={{ marginTop: '100px' }} className='menuiteams-data'>
//             <div
//                 style={{
//                     display: "flex",
//                     flexWrap: "wrap",
//                     gap: "1rem",
//                     marginBottom: "1rem",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     padding: "0rem"
//                 }}
//             >
//                 <style>
//                     {`
//                         @media (max-width: 768px) {
//                             .offers-containers {
//                                 grid-template-columns: repeat(2, 1fr) !important;
//                                 gap: 15px !important;
//                             }
//                             .offers-cards {
//                                 width: 100% !important;
//                                 max-width: 100% !important;
//                             }
//                             .responsive-button-group {
//                                 flex-direction: column !important;
//                                 align-items: center !important;
//                                 width:90vw !important;
//                             }
//                             .responsive-button {
//                                 width: 25% !important;
//                                 text-align: center;
//                             }
//                             .custom-switch-wrapper {
//                                 margin-top: 10px;
//                            left: "-20px"
//                             }
//                         }
                        
//                         @media (max-width: 480px) {
//                             .offers-containers {
//                                 grid-template-columns: 1fr !important;
//                             }
//                             .offers-cards {
//                                 margin: 0 auto !important;
//                             }
//                             .card-body {
//                                 padding: 10px !important;
//                             }
//                             .card-title {
//                                 font-size: 18px !important;
//                             }
//                         }
                        
//                         @media (max-width: 320px) {
//                             .offers-cards {
//                                 width: 95% !important;
//                             }
//                             .card-body {
//                                 padding: 8px !important;
//                             }
//                             .card-title {
//                                 font-size: 16px !important;
//                             }
//                         }
                        
//                         .custom-switch {
//                             position: relative;
//                             display: inline-block;
//                             width: 100px;
//                             height: 35px;
//                         }
                        
//                         .custom-switch input {
//                             opacity: 0;
//                             width: 0;
//                             height: 0;
//                         }
                        
//                         .custom-slideryy {
//                             position: absolute;
//                             cursor: pointer;
//                             transition: 0.4s;
//                             font-weight: bold;
//                             font-size: 14px;
//                             color: #000;
//                             text-align: center;
//                             line-height: 35px;
//                             width: 100px;
//                             height: 40px;
//                             border-radius: 5px;
//                             background-color: rgb(217, 217, 217);
//                         }
                        
//                         .custom-slideryy::before {
//                             content: "";
//                             position: absolute;
//                             height: 16px;
//                             width: 16px;
//                             left: 8px;
//                             top: 13px;
//                             background-color: #000;
//                             transition: 0.4s;
//                             border-radius: 50%;
//                         }
                        
//                         .custom-slideryy.veg::before {
//                             background-color: green;
//                         }
                        
//                         .custom-slideryy.non-veg::before {
//                             background-color: red;
//                         }
                        
//                         .custom-switch input:checked + .custom-slideryy::before {
//                             transform: translateX(60px);
//                         }
//                     `}
//                 </style>

//                 <div
//                     className="responsive-button-group menu-responsive-buttons-code"
//                     style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "start",
//                         alignItems: window.innerWidth < 768 ? "flex-start" : "start",
//                         marginLeft: window.innerWidth < 768 ? "0" : "15px",
//                         width: "100%",
//                         gap: "10px",
//                         marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : window.innerWidth < 768 ? "-25" : "-17px",
//                     }}
//                 >
                    

//                     {/* Bottom Section - Controls */}
//                     <div style={{
//                         display: "flex",
//                         flexDirection: window.innerWidth < 1400 ? "column" : "row",
//                         gap: window.innerWidth < 1400 ? "8px" : "10px",
//                         alignItems: "stretch",
//                         width: "100%",
//                     }}>

//                         {/* Search Bar */}
//                         <div style={{
//                             display: "flex",
//                             justifyContent: window.innerWidth < 1400 ? "flex-end" : "flex-end",
//                             alignItems: "center",
//                             width: "100%",
//                             order: window.innerWidth < 1400 ? 1 : 2,
//                         }}>
//                             <div style={{
//                                 position: "relative",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 width: window.innerWidth < 1400 ?
//                                     (window.innerWidth < 400 ? "100%" : window.innerWidth < 430 ? "97%" :
//                                         window.innerWidth < 768 ? "95%" :
//                                             window.innerWidth < 1200 ? "85%" : "80%") :
//                                     (window.innerWidth < 400 ? "100%" :
//                                         window.innerWidth < 768 ? "95%" :
//                                             "180px"),
//                                 maxWidth: window.innerWidth < 430 ? " " : window.innerWidth < 1400 ? "300px" : "280px",
//                                 marginLeft: window.innerWidth < 1400 ? "auto" : "0",
//                             }}>
//                                 <input
//                                     type="text"
//                                     placeholder="Search dishes..."
//                                     value={searchQuery}
//                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                     onKeyPress={(e) => {
//                                         if (e.key === 'Enter') {
//                                             handleSearch();
//                                         }
//                                     }}
//                                     style={{
//                                         width: "100%",
//                                         padding: window.innerWidth < 400 ? "6px 30px 6px 10px" :
//                                             window.innerWidth < 768 ? "7px 32px 7px 10px" :
//                                                 "8px 35px 8px 12px",
//                                         borderRadius: "20px",
//                                         border: "2px solid #b15cd6",
//                                         fontSize: window.innerWidth < 400 ? "12px" :
//                                             window.innerWidth < 768 ? "12px" :
//                                                 window.innerWidth < 1200 ? "12px" : "13px",
//                                         outline: "none",
//                                         transition: "all 0.3s ease",
//                                         backgroundColor: "#fff",
//                                         height: window.innerWidth < 400 ? "32px" :
//                                             window.innerWidth < 768 ? "33px" : "35px",
//                                     }}
//                                 />
//                                 <button
//                                     onClick={handleSearch}
//                                     style={{
//                                         position: "absolute",
//                                         right: window.innerWidth < 400 ? "5px" : "6px",
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         padding: "4px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center"
//                                     }}
//                                 >
//                                     <svg
//                                         width={window.innerWidth < 400 ? "14" :
//                                             window.innerWidth < 768 ? "15" :
//                                                 window.innerWidth < 1200 ? "16" : "18"}
//                                         height={window.innerWidth < 400 ? "14" :
//                                             window.innerWidth < 768 ? "15" :
//                                                 window.innerWidth < 1200 ? "16" : "18"}
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="#b15cd6"
//                                         strokeWidth="2"
//                                     >
//                                         <circle cx="11" cy="11" r="8" />
//                                         <path d="m21 21-4.3-4.3" />
//                                     </svg>
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Filter Buttons and Order Type */}
//                         <div style={{
//                             display: "flex",
//                             flexDirection: window.innerWidth < 1400 ? "row" : "row",
//                             gap: window.innerWidth < 1400 ?
//                                 (window.innerWidth < 400 ? "8px" :
//                                     window.innerWidth < 768 ? "10px" : "15px") :
//                                 (window.innerWidth < 400 ? "8px" :
//                                     window.innerWidth < 768 ? "10px" : "15px"),
//                             alignItems: "center",
//                             justifyContent: window.innerWidth < 1400 ? "space-between" : "flex-start",
//                             width: "100%",
//                             order: window.innerWidth < 1400 ? 2 : 1,
//                             flexWrap: window.innerWidth < 1400 ? "wrap" : "nowrap",
//                         }}>

//                             {/* Veg/Non-Veg Buttons */}
//                             <div
//                                 className="veg-nonveg-buttons"
//                                 style={{
//                                     display: "flex",
//                                     gap: "10px",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     flexShrink: 0,
//                                 }}
//                             >
//                                 <button
//                                     onClick={() => handleFilterClick("Veg")}
//                                     style={{
//                                         padding: window.innerWidth < 400 ? "4px 10px" :
//                                             window.innerWidth < 768 ? "4px 8px" : "4px 10px",
//                                         backgroundColor: isVegSelected ? "#4CAF50" : "#f0f0f0",
//                                         color: isVegSelected ? "white" : "#666",
//                                         border: isVegSelected ? "2px solid #4CAF50" : "2px solid #ddd",
//                                         borderRadius: "20px",
//                                         fontSize: window.innerWidth < 400 ? "12px" :
//                                             window.innerWidth < 768 ? "14px" : "14px",
//                                         fontWeight: "bold",
//                                         cursor: "pointer",
//                                         transition: "all 0.3s ease",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "5px",
//                                         whiteSpace: "nowrap",
//                                         minWidth: window.innerWidth < 400 ? "60px" : "70px",
//                                         justifyContent: "center"
//                                     }}
//                                 >
//                                     <span style={{
//                                         width: "12px",
//                                         height: "12px",
//                                         backgroundColor: "#4CAF50",
//                                         borderRadius: "50%",
//                                         display: "inline-block",
//                                         border: isVegSelected ? "1px solid white" : "1px solid #4CAF50"
//                                     }}></span>
//                                     Veg
//                                 </button>

//                                 <button
//                                     onClick={() => handleFilterClick("Non-Veg")}
//                                     style={{
//                                         padding: window.innerWidth < 400 ? "4px 10px" :
//                                             window.innerWidth < 768 ? "4px 8px" : "4px 10px",
//                                         backgroundColor: isNonVegSelected ? "#f44336" : "#f0f0f0",
//                                         color: isNonVegSelected ? "white" : "#666",
//                                         border: isNonVegSelected ? "2px solid #f44336" : "2px solid #ddd",
//                                         borderRadius: "20px",
//                                         fontSize: window.innerWidth < 400 ? "12px" :
//                                             window.innerWidth < 768 ? "14px" : "14px",
//                                         fontWeight: "bold",
//                                         cursor: "pointer",
//                                         transition: "all 0.3s ease",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "5px",
//                                         whiteSpace: "nowrap",
//                                         minWidth: window.innerWidth < 400 ? "75px" : "85px",
//                                         justifyContent: "center"
//                                     }}
//                                 >
//                                     <span style={{
//                                         width: "12px",
//                                         height: "12px",
//                                         backgroundColor: "#f44336",
//                                         borderRadius: "50%",
//                                         display: "inline-block",
//                                         border: isNonVegSelected ? "1px solid white" : "1px solid #f44336"
//                                     }}></span>
//                                     Non-Veg
//                                 </button>
//                             </div>

                
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Card Grid */}
//             <div className="offers-containers" style={{
//                 display: 'grid',
//                 gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
//                 gap: '1rem',
//                 padding: '1rem 1rem 7rem 1rem',
//                 justifyItems: 'center'
//             }}>
//                 {allItems.length > 0 ? (
//                     allItems.map((item) => {
//                         const quantity = Number(item.balanceQuantity) || 0;
//                         const isOutOfStock = quantity <= 0;

//                         return (
//                             <div
//                                 key={item.dishId}
//                                 className="offers-cards"
//                                 style={{
//                                     width: '100%',
//                                     maxWidth: '180px',
//                                     borderRadius: '0.75rem',
//                                     overflow: 'hidden',
//                                     boxShadow: isOutOfStock
//                                         ? '0 2px 8px rgba(0, 0, 0, 0.1)'
//                                         : '0 4px 12px rgba(0, 0, 0, 0.1)',
//                                     background: isOutOfStock ? '#f8f9fa' : 'white',
//                                     transition: 'all 0.3s ease',
//                                     border: isOutOfStock
//                                         ? '1px solid #e0e0e0'
//                                         : '1px solid #f0f0f0',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     height: '100%',
//                                     opacity: isOutOfStock ? 0.7 : 1,
//                                     position: 'relative'
//                                 }}
//                             >
//                                 <div style={{
//                                     padding: '0.75rem',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     flexGrow: 1,
//                                     position: 'relative',
//                                     zIndex: 2
//                                 }}>
//                                     <div style={{
//                                         display: "flex",
//                                         alignItems: "flex-start",
//                                         justifyContent: "space-between",
//                                         marginBottom: "0.5rem"
//                                     }}>
//                                         <h5 style={{
//                                             fontSize: "1rem",
//                                             margin: 0,
//                                             fontWeight: "600",
//                                             color: isOutOfStock ? "#888" : "#333",
//                                             lineHeight: "1.2",
//                                             flex: 1,
//                                             marginRight: "0.5rem"
//                                         }}>
//                                             {item.dishName}
//                                         </h5>

//                                         {item.tag === "Veg" ? (
//                                             <div style={{
//                                                 width: "12px",
//                                                 height: "12px",
//                                                 border: `1.5px solid ${isOutOfStock ? '#888' : 'green'}`,
//                                                 borderRadius: "2px",
//                                                 position: "relative",
//                                                 flexShrink: 0,
//                                                 marginTop: "0.25rem"
//                                             }}>
//                                                 <div style={{
//                                                     width: "6px",
//                                                     height: "6px",
//                                                     backgroundColor: isOutOfStock ? '#888' : 'green',
//                                                     borderRadius: "50%",
//                                                     position: "absolute",
//                                                     top: "50%",
//                                                     left: "50%",
//                                                     transform: "translate(-50%, -50%)",
//                                                 }}></div>
//                                             </div>
//                                         ) : (
//                                             <div style={{
//                                                 width: "12px",
//                                                 height: "12px",
//                                                 border: `1.5px solid ${isOutOfStock ? '#888' : 'red'}`,
//                                                 borderRadius: "2px",
//                                                 position: "relative",
//                                                 flexShrink: 0,
//                                                 marginTop: "0.25rem"
//                                             }}>
//                                                 <div style={{
//                                                     width: "6px",
//                                                     height: "6px",
//                                                     backgroundColor: isOutOfStock ? '#888' : 'red',
//                                                     borderRadius: "50%",
//                                                     position: "absolute",
//                                                     top: "50%",
//                                                     left: "50%",
//                                                     transform: "translate(-50%, -50%)",
//                                                 }}></div>
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ flexGrow: 1 }}></div>

//                                     <div style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '0.5rem',
//                                         marginBottom: '0.75rem'
//                                     }}>
//                                         {item.price > item.effectivePrice ? (
//                                             <>
//                                                 <span style={{
//                                                     fontSize: '0.8rem',
//                                                     color: isOutOfStock ? '#aaa' : 'gray',
//                                                     textDecoration: 'line-through'
//                                                 }}>
//                                                     <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '0.7rem' }}></i>
//                                                     {item.price}
//                                                 </span>
//                                                 <span style={{
//                                                     fontSize: '0.9rem',
//                                                     fontWeight: 'bold',
//                                                     color: isOutOfStock ? '#888' : '#333'
//                                                 }}>
//                                                     <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
//                                                     {item.effectivePrice}
//                                                 </span>
//                                             </>
//                                         ) : (
//                                             <span style={{
//                                                 fontSize: '0.9rem',
//                                                 fontWeight: 'bold',
//                                                 color: isOutOfStock ? '#888' : '#333'
//                                             }}>
//                                                 <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
//                                                 {item.price}
//                                             </span>
//                                         )}
//                                     </div>

//                                     <div style={{ textAlign: "center" }}>
//                                         {isOutOfStock ? (
//                                             <button
//                                                 disabled
//                                                 style={{
//                                                     background: "#cccccc",
//                                                     color: "#666666",
//                                                     width: "100%",
//                                                     borderRadius: "1.5rem",
//                                                     padding: "0.5rem",
//                                                     border: "none",
//                                                     fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
//                                                     fontWeight: "500",
//                                                     cursor: "not-allowed",
//                                                     opacity: 0.6
//                                                 }}
//                                             >
//                                                 Out of Stock
//                                             </button>
//                                         ) : cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
//                                             <div style={{
//                                                 display: 'flex',
//                                                 justifyContent: 'space-evenly',
//                                                 alignItems: 'center',
//                                                 background: '#b15dc6',
//                                                 borderRadius: '1.5rem',
//                                                 padding: window.innerWidth < 900 ? "0.25rem 0.5rem" : '0.25rem 0.5rem',
//                                                 color: 'white'
//                                             }}>
//                                                 <button
//                                                     onClick={() => decreaseQuantity(item.dishId)}
//                                                     style={{
//                                                         background: 'none',
//                                                         border: 'none',
//                                                         color: 'white',
//                                                         fontSize: '1rem',
//                                                         cursor: 'pointer',
//                                                         padding: '0.25rem 0.5rem',
//                                                         minWidth: '30px'
//                                                     }}
//                                                 >
//                                                     -
//                                                 </button>
//                                                 <span style={{
//                                                     fontSize: '0.9rem',
//                                                     fontWeight: 'bold',
//                                                     minWidth: '1.5rem',
//                                                     textAlign: 'center'
//                                                 }}>
//                                                     {quantities[item.dishId] || 1}
//                                                 </span>
//                                                 <button
//                                                     onClick={() => increaseQuantity(item.dishId)}
//                                                     style={{
//                                                         background: 'none',
//                                                         border: 'none',
//                                                         color: 'white',
//                                                         fontSize: '1rem',
//                                                         cursor: 'pointer',
//                                                         padding: '0.25rem 0.5rem',
//                                                         minWidth: '30px'
//                                                     }}
//                                                 >
//                                                     +
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             <button
//                                                 onClick={async () => {
//                                                     setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
//                                                     await addToCart(item, 1);
//                                                 }}
//                                                 style={{
//                                                     background: "#b15dc6",
//                                                     color: "#fff",
//                                                     width: "100%",
//                                                     borderRadius: "1.5rem",
//                                                     padding: "0.5rem",
//                                                     border: "none",
//                                                     fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
//                                                     fontWeight: "500",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 Add To Cart
//                                             </button>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     })
//                 ) : (
//                     <div style={{
//                         gridColumn: "1 / -1",
//                         textAlign: "center",
//                         padding: "3rem",
//                         color: "#666",
//                         fontSize: "1.1rem",
//                         width: "100%"
//                     }}>
//                         {searchQuery ? `No dishes found matching "${searchQuery}"` : "No dishes available"}
//                     </div>
//                 )}
//             </div>

//             {/* Remove Confirmation Modal */}
//             <Modal
//                 isOpen={showRemoveConfirm}
//                 onRequestClose={cancelRemove}
//                 contentLabel="Remove Item Confirmation"
//                 style={{
//                     overlay: {
//                         backgroundColor: "rgba(0, 0, 0, 0.5)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         zIndex: 9999
//                     },
//                     content: {
//                         position: "relative",
//                         top: "auto",
//                         left: "auto",
//                         right: "auto",
//                         bottom: "auto",
//                         width: "90%",
//                         maxWidth: "400px",
//                         margin: "0 auto",
//                         border: "none",
//                         borderRadius: "10px",
//                         padding: "2rem",
//                         textAlign: "center",
//                         boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
//                         backgroundColor: "white"
//                     }
//                 }}
//             >
//                 <div style={{ textAlign: "center" }}>
//                     <h3 style={{
//                         color: "#2d3748",
//                         marginBottom: "1rem",
//                         fontSize: "1.3rem"
//                     }}>
//                         Remove Item
//                     </h3>
//                     <p style={{
//                         color: "#718096",
//                         marginBottom: "2rem",
//                         fontSize: "1rem",
//                         lineHeight: "1.5"
//                     }}>
//                         Are you sure you want to remove<br />
//                         <strong>"{itemToRemove?.cartItem?.dishName || "this item"}"</strong><br />
//                         from your cart?
//                     </p>
//                     <div style={{
//                         display: "flex",
//                         gap: "1rem",
//                         justifyContent: "center"
//                     }}>
//                         <button
//                             onClick={cancelRemove}
//                             style={{
//                                 padding: "0.75rem 1.5rem",
//                                 border: "2px solid #e2e8f0",
//                                 background: "white",
//                                 color: "#4a5568",
//                                 borderRadius: "0.5rem",
//                                 cursor: "pointer",
//                                 fontWeight: "600",
//                                 fontSize: "1rem",
//                                 transition: "all 0.2s ease"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.target.style.borderColor = "#b15cd6";
//                                 e.target.style.color = "#b15cd6";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.target.style.borderColor = "#e2e8f0";
//                                 e.target.style.color = "#4a5568";
//                             }}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             onClick={confirmRemove}
//                             style={{
//                                 padding: "0.75rem 1.5rem",
//                                 border: "none",
//                                 background: "#e53e3e",
//                                 color: "white",
//                                 borderRadius: "0.5rem",
//                                 cursor: "pointer",
//                                 fontWeight: "600",
//                                 fontSize: "1rem",
//                                 transition: "all 0.2s ease"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.target.style.background = "#c53030";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.target.style.background = "#e53e3e";
//                             }}
//                         >
//                             Remove
//                         </button>
//                     </div>
//                 </div>
//             </Modal>
//         </div>
//     );
// };

// export default WaitermenuIteams;



import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

Modal.setAppElement('#root');
const WaitermenuIteams = ({ parentId }) => {
    const [dishes, setDishes] = useState([]);
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const [cartData, setCartData] = useState({ cartItems: [] });
    const [refresh, setRefresh] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
    const [itemToRemove, setItemToRemove] = useState(null);
    const [grandTotal, setGrandTotal] = useState(0);
    
    // Order type for waiter is fixed as TABLE_DINE_IN
    const selectedOrderType = "TABLE_DINE_IN";

    const handleSearch = () => {
        if (!searchQuery.trim()) {
            applyCurrentFilters();
            return;
        }

        const searchTerm = searchQuery.toLowerCase().trim();
        const searchResults = dishes.filter(dish =>
            dish.dishName.toLowerCase().includes(searchTerm)
        );

        if (searchResults.length > 0) {
            setFilteredDishes(searchResults);
        } else {
            setFilteredDishes([]);
        }
    };

    useEffect(() => {
        handleSearch();
    }, [searchQuery, dishes]);

    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        window.addEventListener('cartUpdated', handleCartUpdate);
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    const applyCurrentFilters = () => {
        let filtered = dishes;

        if (isVegSelected) {
            filtered = filtered.filter(dish => dish.tag === 'Veg');
        } else if (isNonVegSelected) {
            filtered = filtered.filter(dish => dish.tag === 'Non_Veg');
        }

        setFilteredDishes(filtered);
    };

    const handleFilterClick = (type) => {
        if (type === 'Veg') {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
            setIsAllSelected(false);
            applyFilter('Veg');
        } else if (type === 'Non-Veg') {
            setIsVegSelected(false);
            setIsNonVegSelected(true);
            setIsAllSelected(false);
            applyFilter('Non_Veg');
        } else {
            setIsVegSelected(false);
            setIsNonVegSelected(false);
            setIsAllSelected(true);
            setFilteredDishes(dishes);
        }
    };

    useEffect(() => {
        if (dishes.length > 0) {
            if (isVegSelected) {
                applyFilter('Veg');
            } else if (isNonVegSelected) {
                applyFilter('Non_Veg');
            } else {
                setFilteredDishes(dishes);
            }
        }
    }, [dishes, isVegSelected, isNonVegSelected]);

    const authToken = localStorage.getItem("authToken");
    const vendorId = localStorage.getItem("vendorId");

    const triggerCartRefresh = () => {
        const event = new CustomEvent('cartUpdated');
        window.dispatchEvent(event);
    }

    // Fetch cart data for table
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const seatingId = localStorage.getItem("seatingId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !seatingId || !authToken) {
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/getby/table/${vendorId}/${seatingId}`,
                { 
                    headers: { 
                        Authorization: `Bearer ${authToken}`,
                        "Cache-Control": "no-cache"
                    } 
                }
            );
            
            if (response.data) {
                setCartData(response.data);
                setGrandTotal(response.data.grandTotal || 0);

                const initialQuantities = {};
                if (response.data.cartItems) {
                    response.data.cartItems.forEach(item => {
                        initialQuantities[item.dishId] = item.quantity;
                    });
                }
                setQuantities(initialQuantities);
            }
        } catch (err) {
            console.error("Error fetching cart:", err);
        }
    };

    const increaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const cartId = cartData.cartId; // Use cartId from cartData

        if (!token || !vendorId || !cartId) {
            alert("Auth token, vendorId, or cartId missing");
            return;
        }

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) {
            alert("Item not found in cart. Please add it first.");
            return;
        }

        const newQty = (quantities[dishId] || 0) + 1;

        // Use the update endpoint for table cart
        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${dishId}&quantity=${newQty}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            // Update local state immediately
            setQuantities(prev => ({ ...prev, [dishId]: newQty }));
            setCartData(prev => ({
                ...prev,
                cartItems: prev.cartItems.map(item =>
                    item.dishId === dishId ? { ...item, quantity: newQty } : item
                )
            }));

            // Refresh cart data to get updated totals
            await fetchCartData();
            triggerCartRefresh();

            setIsModalOpen(true);
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Insufficient stock! Can't add more");
        }
    };

    const decreaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const currentQty = quantities[dishId] || 0;
        
        if (currentQty === 0) return;

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) return alert("Item not found");

        const newQty = currentQty - 1;

        // If quantity becomes 0, show confirmation
        if (newQty === 0) {
            setItemToRemove({ dishId, cartItem });
            setShowRemoveConfirm(true);
            return;
        }

        // Otherwise update normally
        await updateQuantity(dishId, newQty);
    };

    const updateQuantity = async (dishId, newQty) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const cartId = cartData.cartId;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartId}?dishId=${dishId}&quantity=${newQty}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            // Update local state immediately
            setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
            setCartData(prev => ({
                ...prev,
                cartItems: newQty > 0
                    ? prev.cartItems.map(item =>
                        item.dishId === dishId ? { ...item, quantity: newQty } : item
                    )
                    : prev.cartItems.filter(item => item.dishId !== dishId)
            }));

            // Refresh cart data to get updated totals
            await fetchCartData();
            triggerCartRefresh();

            setIsModalOpen(true);
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity");
        }
    };

    const confirmRemove = async () => {
        if (itemToRemove) {
            await updateQuantity(itemToRemove.dishId, 0);
            setShowRemoveConfirm(false);
            setItemToRemove(null);
        }
    };

    const cancelRemove = () => {
        setShowRemoveConfirm(false);
        setItemToRemove(null);
    };

    useEffect(() => {
        fetchCartData();
    }, [authToken, vendorId, refresh]);

    // Add to cart for waiter/table
    const addToCart = async (item, quantity = 1) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");
        const seatingId = localStorage.getItem("seatingId");
        const tableCode = localStorage.getItem("tableCode");

        if (!seatingId || !tableCode) {
            console.error("❌ Seating ID or Table Code not found in localStorage");
            alert("Table information missing. Please select a table first.");
            return;
        }

        // Use waiter-order endpoint for initial add
        const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;
        const data = [{ dishId: item.dishId, quantity }];

        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                // After adding, fetch the cart data
                await fetchCartData();
                triggerCartRefresh();
                setIsModalOpen(true);
                setTimeout(() => {
                    if (!isHovered) setIsModalOpen(false);
                }, 2000);
            } else {
                alert('Failed to add item to cart');
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);
            if (error.response) {
                alert(`Error: ${error.response.data.message || error.response.statusText}`);
            } else {
                alert('An unexpected error occurred. Please try again.');
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId) {
                console.warn("⚠️ vendorId not found in localStorage");
                setError(new Error("vendorId missing"));
                setLoading(false);
                return;
            }

            if (!token) {
                console.warn("⚠️ authToken not found in localStorage");
                setError(new Error("authToken missing"));
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                const dishData = Array.isArray(data) ? data : data.data || [];
                const validDishData = dishData.filter(item => item !== null && item !== undefined);

                // Show all items (removed quantity check)
                const filteredData = validDishData.filter(item => {
                    const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
                    const statusCheck = item.menuStatus === "Enable";
                    return parentCheck && statusCheck;
                });

                setDishes(filteredData);
                setFilteredDishes(filteredData);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [parentId]);

    // Global search hotkey functionality
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            const isTypingInInput =
                e.target.tagName === 'INPUT' ||
                e.target.tagName === 'TEXTAREA' ||
                e.target.isContentEditable;

            if (e.key === '/' && !isTypingInInput) {
                e.preventDefault();
                const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
                if (searchInput) {
                    searchInput.focus();
                    searchInput.select();
                }
            }

            const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]:focus');
            if (searchInput && !isTypingInInput) {
                if (e.key === 'Backspace') {
                    e.preventDefault();
                    setSearchQuery(prev => prev.slice(0, -1));
                }
                else if (e.key === 'Escape') {
                    e.preventDefault();
                    searchInput.blur();
                    setSearchQuery("");
                }
            }

            if (!isTypingInInput &&
                e.key.length === 1 &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                e.key !== ' ') {

                const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');

                if (searchInput) {
                    if (document.activeElement !== searchInput) {
                        e.preventDefault();
                        searchInput.focus();
                        setSearchQuery(e.key);
                    }
                }
            }
        };

        window.addEventListener('keydown', handleGlobalKeyDown);
        return () => {
            window.removeEventListener('keydown', handleGlobalKeyDown);
        };
    }, [searchQuery]);

    const applyFilter = (filterType) => {
        let filtered = dishes;

        if (filterType === 'Veg') {
            filtered = dishes.filter(dish => dish.tag === 'Veg');
        } else if (filterType === 'Non_Veg') {
            filtered = dishes.filter(dish => dish.tag === 'Non_Veg');
        }

        if (searchQuery.trim()) {
            const searchTerm = searchQuery.toLowerCase().trim();
            filtered = filtered.filter(dish =>
                dish.dishName.toLowerCase().includes(searchTerm)
            );
        }

        setFilteredDishes(filtered);
    };

    const separateInStockAndOutOfStock = (items) => {
        const inStock = [];
        const outOfStock = [];

        items.forEach(item => {
            const quantity = Number(item.balanceQuantity) || 0;
            if (quantity > 0) {
                inStock.push(item);
            } else {
                outOfStock.push(item);
            }
        });

        return { inStock, outOfStock };
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading dishes: {error.message}</div>;
    }

    const { inStock, outOfStock } = separateInStockAndOutOfStock(filteredDishes);
    const allItems = [...inStock, ...outOfStock];

    return (
        <div style={{ marginTop: '100px' }} className='menuiteams-data'>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    marginBottom: "1rem",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0rem"
                }}
            >
                <style>
                    {`
                        @media (max-width: 768px) {
                            .offers-containers {
                                grid-template-columns: repeat(2, 1fr) !important;
                                gap: 15px !important;
                            }
                            .offers-cards {
                                width: 100% !important;
                                max-width: 100% !important;
                            }
                            .responsive-button-group {
                                flex-direction: column !important;
                                align-items: center !important;
                                width:90vw !important;
                            }
                            .responsive-button {
                                width: 25% !important;
                                text-align: center;
                            }
                            .custom-switch-wrapper {
                                margin-top: 10px;
                           left: "-20px"
                            }
                        }
                        
                        @media (max-width: 480px) {
                            // .offers-containers {
                            //     grid-template-columns: 1fr !important;
                            // }
                            .offers-cards {
                                margin: 0 auto !important;
                            }
                            .card-body {
                                padding: 10px !important;
                            }
                            .card-title {
                                font-size: 18px !important;
                            }
                        }
                        
                        @media (max-width: 320px) {
                            .offers-cards {
                                width: 95% !important;
                            }
                            .card-body {
                                padding: 8px !important;
                            }
                            .card-title {
                                font-size: 16px !important;
                            }
                        }
                        
                        .custom-switch {
                            position: relative;
                            display: inline-block;
                            width: 100px;
                            height: 35px;
                        }
                        
                        .custom-switch input {
                            opacity: 0;
                            width: 0;
                            height: 0;
                        }
                        
                        .custom-slideryy {
                            position: absolute;
                            cursor: pointer;
                            transition: 0.4s;
                            font-weight: bold;
                            font-size: 14px;
                            color: #000;
                            text-align: center;
                            line-height: 35px;
                            width: 100px;
                            height: 40px;
                            border-radius: 5px;
                            background-color: rgb(217, 217, 217);
                        }
                        
                        .custom-slideryy::before {
                            content: "";
                            position: absolute;
                            height: 16px;
                            width: 16px;
                            left: 8px;
                            top: 13px;
                            background-color: #000;
                            transition: 0.4s;
                            border-radius: 50%;
                        }
                        
                        .custom-slideryy.veg::before {
                            background-color: green;
                        }
                        
                        .custom-slideryy.non-veg::before {
                            background-color: red;
                        }
                        
                        .custom-switch input:checked + .custom-slideryy::before {
                            transform: translateX(60px);
                        }
                    `}
                </style>

                <div
                    className="responsive-button-group menu-responsive-buttons-code"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                        alignItems: window.innerWidth < 768 ? "flex-start" : "start",
                        marginLeft: window.innerWidth < 768 ? "0" : "15px",
                        width: "100%",
                        gap: "10px",
                        marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : window.innerWidth < 768 ? "-25" : "-17px",
                    }}
                >
                    {/* Only keep the bottom section - no Menu and Add Items buttons */}
                    <div style={{
                        display: "flex",
                        flexDirection: window.innerWidth < 1400 ? "column" : "row",
                        gap: window.innerWidth < 1400 ? "8px" : "10px",
                        alignItems: "stretch",
                        width: "100%",
                    }}>

                        {/* Search Bar */}
                        <div style={{
                            display: "flex",
                            justifyContent: window.innerWidth < 1400 ? "flex-end" : "flex-end",
                            alignItems: "center",
                            width: "100%",
                            order: window.innerWidth < 1400 ? 1 : 2,
                        }}>
                            <div style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                width: window.innerWidth < 1400 ?
                                    (window.innerWidth < 400 ? "100%" : window.innerWidth < 430 ? "97%" :
                                        window.innerWidth < 768 ? "95%" :
                                            window.innerWidth < 1200 ? "85%" : "80%") :
                                    (window.innerWidth < 400 ? "100%" :
                                        window.innerWidth < 768 ? "95%" :
                                            "180px"),
                                maxWidth: window.innerWidth < 430 ? " " : window.innerWidth < 1400 ? "300px" : "280px",
                                marginLeft: window.innerWidth < 1400 ? "auto" : "0",
                            }}>
                                <input
                                    type="text"
                                    placeholder="Search dishes..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch();
                                        }
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: window.innerWidth < 400 ? "6px 30px 6px 10px" :
                                            window.innerWidth < 768 ? "7px 32px 7px 10px" :
                                                "8px 35px 8px 12px",
                                        borderRadius: "20px",
                                        border: "2px solid #b15cd6",
                                        fontSize: window.innerWidth < 400 ? "12px" :
                                            window.innerWidth < 768 ? "12px" :
                                                window.innerWidth < 1200 ? "12px" : "13px",
                                        outline: "none",
                                        transition: "all 0.3s ease",
                                        backgroundColor: "#fff",
                                        height: window.innerWidth < 400 ? "32px" :
                                            window.innerWidth < 768 ? "33px" : "35px",
                                    }}
                                />
                                <button
                                    onClick={handleSearch}
                                    style={{
                                        position: "absolute",
                                        right: window.innerWidth < 400 ? "5px" : "6px",
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <svg
                                        width={window.innerWidth < 400 ? "14" :
                                            window.innerWidth < 768 ? "15" :
                                                window.innerWidth < 1200 ? "16" : "18"}
                                        height={window.innerWidth < 400 ? "14" :
                                            window.innerWidth < 768 ? "15" :
                                                window.innerWidth < 1200 ? "16" : "18"}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#b15cd6"
                                        strokeWidth="2"
                                    >
                                        <circle cx="11" cy="11" r="8" />
                                        <path d="m21 21-4.3-4.3" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Filter Buttons */}
                        <div style={{
                            display: "flex",
                            flexDirection: window.innerWidth < 1400 ? "row" : "row",
                            gap: window.innerWidth < 1400 ?
                                (window.innerWidth < 400 ? "8px" :
                                    window.innerWidth < 768 ? "10px" : "15px") :
                                (window.innerWidth < 400 ? "8px" :
                                    window.innerWidth < 768 ? "10px" : "15px"),
                            alignItems: "center",
                            justifyContent: window.innerWidth < 1400 ? "space-between" : "flex-start",
                            width: "100%",
                            order: window.innerWidth < 1400 ? 2 : 1,
                            flexWrap: window.innerWidth < 1400 ? "wrap" : "nowrap",
                        }}>

                            {/* Veg/Non-Veg Buttons */}
                            <div
                                className="veg-nonveg-buttons"
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <button
                                    onClick={() => handleFilterClick("Veg")}
                                    style={{
                                        padding: window.innerWidth < 400 ? "4px 10px" :
                                            window.innerWidth < 768 ? "4px 8px" : "4px 10px",
                                        backgroundColor: isVegSelected ? "#4CAF50" : "#f0f0f0",
                                        color: isVegSelected ? "white" : "#666",
                                        border: isVegSelected ? "2px solid #4CAF50" : "2px solid #ddd",
                                        borderRadius: "20px",
                                        fontSize: window.innerWidth < 400 ? "12px" :
                                            window.innerWidth < 768 ? "14px" : "14px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        whiteSpace: "nowrap",
                                        minWidth: window.innerWidth < 400 ? "60px" : "70px",
                                        justifyContent: "center"
                                    }}
                                >
                                    <span style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: "#4CAF50",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        border: isVegSelected ? "1px solid white" : "1px solid #4CAF50"
                                    }}></span>
                                    Veg
                                </button>

                                <button
                                    onClick={() => handleFilterClick("Non-Veg")}
                                    style={{
                                        padding: window.innerWidth < 400 ? "4px 10px" :
                                            window.innerWidth < 768 ? "4px 8px" : "4px 10px",
                                        backgroundColor: isNonVegSelected ? "#f44336" : "#f0f0f0",
                                        color: isNonVegSelected ? "white" : "#666",
                                        border: isNonVegSelected ? "2px solid #f44336" : "2px solid #ddd",
                                        borderRadius: "20px",
                                        fontSize: window.innerWidth < 400 ? "12px" :
                                            window.innerWidth < 768 ? "14px" : "14px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        whiteSpace: "nowrap",
                                        minWidth: window.innerWidth < 400 ? "75px" : "85px",
                                        justifyContent: "center"
                                    }}
                                >
                                    <span style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: "#f44336",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        border: isNonVegSelected ? "1px solid white" : "1px solid #f44336"
                                    }}></span>
                                    Non-Veg
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card Grid - Same as MenuItems */}
            <div className="offers-containers" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                gap: '1rem',
                padding: '1rem 1rem 7rem 1rem',
                justifyItems: 'center'
            }}>
                {allItems.length > 0 ? (
                    allItems.map((item) => {
                        const quantity = Number(item.balanceQuantity) || 0;
                        const isOutOfStock = quantity <= 0;

                        return (
                            <div
                                key={item.dishId}
                                className="offers-cards"
                                style={{
                                    width: '100%',
                                    maxWidth: '180px',
                                    borderRadius: '0.75rem',
                                    overflow: 'hidden',
                                    boxShadow: isOutOfStock
                                        ? '0 2px 8px rgba(0, 0, 0, 0.1)'
                                        : '0 4px 12px rgba(0, 0, 0, 0.1)',
                                    background: isOutOfStock ? '#f8f9fa' : 'white',
                                    transition: 'all 0.3s ease',
                                    border: isOutOfStock
                                        ? '1px solid #e0e0e0'
                                        : '1px solid #f0f0f0',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                    opacity: isOutOfStock ? 0.7 : 1,
                                    position: 'relative'
                                }}
                            >
                                <div style={{
                                    padding: '0.75rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flexGrow: 1,
                                    position: 'relative',
                                    zIndex: 2
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "space-between",
                                        marginBottom: "0.5rem"
                                    }}>
                                        <h5 style={{
                                            fontSize: "1rem",
                                            margin: 0,
                                            fontWeight: "600",
                                            color: isOutOfStock ? "#888" : "#333",
                                            lineHeight: "1.2",
                                            flex: 1,
                                            marginRight: "0.5rem"
                                        }}>
                                            {item.dishName}
                                        </h5>

                                        {item.tag === "Veg" ? (
                                            <div style={{
                                                width: "12px",
                                                height: "12px",
                                                border: `1.5px solid ${isOutOfStock ? '#888' : 'green'}`,
                                                borderRadius: "2px",
                                                position: "relative",
                                                flexShrink: 0,
                                                marginTop: "0.25rem"
                                            }}>
                                                <div style={{
                                                    width: "6px",
                                                    height: "6px",
                                                    backgroundColor: isOutOfStock ? '#888' : 'green',
                                                    borderRadius: "50%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}></div>
                                            </div>
                                        ) : (
                                            <div style={{
                                                width: "12px",
                                                height: "12px",
                                                border: `1.5px solid ${isOutOfStock ? '#888' : 'red'}`,
                                                borderRadius: "2px",
                                                position: "relative",
                                                flexShrink: 0,
                                                marginTop: "0.25rem"
                                            }}>
                                                <div style={{
                                                    width: "6px",
                                                    height: "6px",
                                                    backgroundColor: isOutOfStock ? '#888' : 'red',
                                                    borderRadius: "50%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}></div>
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ flexGrow: 1 }}></div>

                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        marginBottom: '0.75rem'
                                    }}>
                                        {item.price > item.effectivePrice ? (
                                            <>
                                                <span style={{
                                                    fontSize: '0.8rem',
                                                    color: isOutOfStock ? '#aaa' : 'gray',
                                                    textDecoration: 'line-through'
                                                }}>
                                                    <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '0.7rem' }}></i>
                                                    {item.price}
                                                </span>
                                                <span style={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: 'bold',
                                                    color: isOutOfStock ? '#888' : '#333'
                                                }}>
                                                    <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
                                                    {item.effectivePrice}
                                                </span>
                                            </>
                                        ) : (
                                            <span style={{
                                                fontSize: '0.9rem',
                                                fontWeight: 'bold',
                                                color: isOutOfStock ? '#888' : '#333'
                                            }}>
                                                <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
                                                {item.price}
                                            </span>
                                        )}
                                    </div>

                                    <div style={{ textAlign: "center" }}>
                                        {isOutOfStock ? (
                                            <button
                                                disabled
                                                style={{
                                                    background: "#cccccc",
                                                    color: "#666666",
                                                    width: "100%",
                                                    borderRadius: "1.5rem",
                                                    padding: "0.5rem",
                                                    border: "none",
                                                    fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
                                                    fontWeight: "500",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6
                                                }}
                                            >
                                                Out of Stock
                                            </button>
                                        ) : cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-around',
                                                alignItems: 'center',
                                                background: '#b15dc6',
                                                borderRadius: '1.5rem',
                                                padding: window.innerWidth < 900 ? "0.25rem 0.5rem" : '0.25rem 0.5rem',
                                                color: 'white'
                                            }}>
                                                <button
                                                    onClick={() => decreaseQuantity(item.dishId)}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: 'white',
                                                        fontSize: '1rem',
                                                        cursor: 'pointer',
                                                        padding: '0.25rem'
                                                    }}
                                                >
                                                    -
                                                </button>
                                                <span style={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: 'bold',
                                                    minWidth: '1.5rem',
                                                    textAlign: 'center'
                                                }}>
                                                    {quantities[item.dishId] || 1}
                                                </span>
                                                <button
                                                    onClick={() => increaseQuantity(item.dishId)}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: 'white',
                                                        fontSize: '1rem',
                                                        cursor: 'pointer',
                                                        padding: '0.25rem'
                                                    }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={async () => {
                                                    setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
                                                    await addToCart(item, 1);
                                                }}
                                                style={{
                                                    background: "#b15dc6",
                                                    color: "#fff",
                                                    width: "100%",
                                                    borderRadius: "1.5rem",
                                                    padding: "0.5rem",
                                                    border: "none",
                                                    fontSize: window.innerWidth < 500 ? "0.7rem" : "1rem",
                                                    fontWeight: "500",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Add To Cart
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div style={{
                        gridColumn: "1 / -1",
                        textAlign: "center",
                        padding: "3rem",
                        color: "#666",
                        fontSize: "1.1rem",
                        width: "100%"
                    }}>
                        {searchQuery ? `No dishes found matching "${searchQuery}"` : "No dishes available"}
                    </div>
                )}
            </div>

            {/* Remove Confirmation Modal */}
            <Modal
                isOpen={showRemoveConfirm}
                onRequestClose={cancelRemove}
                contentLabel="Remove Item Confirmation"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    },
                    content: {
                        position: "relative",
                        top: "auto",
                        left: "auto",
                        right: "auto",
                        bottom: "auto",
                        width: "90%",
                        maxWidth: "400px",
                        margin: "0 auto",
                        border: "none",
                        borderRadius: "10px",
                        padding: "2rem",
                        textAlign: "center",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                        backgroundColor: "white"
                    }
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <h3 style={{
                        color: "#2d3748",
                        marginBottom: "1rem",
                        fontSize: "1.3rem"
                    }}>
                        Remove Item
                    </h3>
                    <p style={{
                        color: "#718096",
                        marginBottom: "2rem",
                        fontSize: "1rem",
                        lineHeight: "1.5"
                    }}>
                        Are you sure you want to remove<br />
                        <strong>"{itemToRemove?.cartItem?.dishName || "this item"}"</strong><br />
                        from your cart?
                    </p>
                    <div style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "center"
                    }}>
                        <button
                            onClick={cancelRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "2px solid #e2e8f0",
                                background: "white",
                                color: "#4a5568",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.borderColor = "#b15cd6";
                                e.target.style.color = "#b15cd6";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.color = "#4a5568";
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={confirmRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "none",
                                background: "#e53e3e",
                                color: "white",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.background = "#c53030";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.background = "#e53e3e";
                            }}
                        >
                            Remove
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default WaitermenuIteams;